"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8840],{

/***/ 58840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(27812);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(50029);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2185);
/* harmony import */ var api_apiInstance__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85503);
/* harmony import */ var api_commonConstants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96781);
/* harmony import */ var api_constants__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(9041);
/* harmony import */ var constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(97208);
/* harmony import */ var constants_loginConstants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(56036);
/* harmony import */ var localization_i8intl__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(54269);
/* harmony import */ var redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(8969);
/* harmony import */ var redux_actions_bookmarksActions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(73295);
/* harmony import */ var redux_actions_postAction__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(25609);
/* harmony import */ var utils_deviceIdGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(32710);
/* harmony import */ var utils_encryption__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34071);
/* harmony import */ var utils_uiHelper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(19150);
/* harmony import */ var _FontSize__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(66707);
/* harmony import */ var _Ads_index__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(99126);
/* harmony import */ var constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(39712);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(10682);
/* harmony import */ var redux_actions_seriesAction__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(98033);
/* harmony import */ var constants_cricket__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(34044);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(85893);






















 // import ElectionsWidget from "components/elections-2023/ElectionsWidget";
// import {
//   fetchAndActivate,
//   getRemoteConfig,
//   getString,
// } from "firebase/remote-config";
// import app from "utils/firebase";
// import FAQComponent from "components/faq";
// import RecengineWidget from "./RecengineWidget";


 // import WidgetHome from "components/cricket/WidgetHome";
// Optimize next-share (social buttons)

var FacebookShareButton = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 1818).then(__webpack_require__.bind(__webpack_require__, 21818)).then(function (mod) {
    return mod.FacebookShareButton;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(21818)];
    }
  }
});
var TwitterShareButton = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 1818).then(__webpack_require__.bind(__webpack_require__, 21818)).then(function (mod) {
    return mod.TwitterShareButton;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(21818)];
    }
  }
});
var WhatsappShareButton = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 1818).then(__webpack_require__.bind(__webpack_require__, 21818)).then(function (mod) {
    return mod.WhatsappShareButton;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(21818)];
    }
  }
});


 // import MoreEpisodes from "./MoreEpisodes";




var MoreEpisodes = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(6486), __webpack_require__.e(3192)]).then(__webpack_require__.bind(__webpack_require__, 73192));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(73192)];
    }
  }
}); // Optimize react-intl

var FormattedMessage = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 3443).then(__webpack_require__.bind(__webpack_require__, 83443)).then(function (mod) {
    return mod.FormattedMessage;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(83443)];
    }
  }
});
var WidgetHome = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(8087), __webpack_require__.e(7173)]).then(__webpack_require__.bind(__webpack_require__, 70014));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(70014)];
    }
  }
});
var RecengineWidget = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 4545).then(__webpack_require__.bind(__webpack_require__, 94545));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(94545)];
    }
  }
});
var FAQComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 4892).then(__webpack_require__.bind(__webpack_require__, 74892));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(74892)];
    }
  }
});
var CommentSection = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6185), __webpack_require__.e(5454), __webpack_require__.e(3439)]).then(__webpack_require__.bind(__webpack_require__, 75454));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(75454)];
    }
  }
});
var ArticleHTML = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(7758), __webpack_require__.e(719), __webpack_require__.e(8764), __webpack_require__.e(653), __webpack_require__.e(7087)]).then(__webpack_require__.bind(__webpack_require__, 51458));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(51458)];
    }
  }
});
var DynamicBanner = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3057)]).then(__webpack_require__.bind(__webpack_require__, 43057));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(43057)];
    }
  }
});
var TrendingToday = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(1244)]).then(__webpack_require__.bind(__webpack_require__, 51244));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(51244)];
    }
  }
});
var CommentPopup = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 2133).then(__webpack_require__.bind(__webpack_require__, 22133));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(22133)];
    }
  }
});
var CustomPopup = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function () {
  return __webpack_require__.e(/* import() */ 8773).then(__webpack_require__.bind(__webpack_require__, 78773));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(78773)];
    }
  }
}); // const ReactJWPlayer = dynamic(() => import("react-jw-player"), { ssr: true });

var VideoPage = function VideoPage(_ref) {
  var _postData$createdByEm, _arraysData$indexonSc17, _arraysData$indexonSc18, _arraysData$indexonSc19, _arraysData$indexonSc20, _arraysData$indexonSc21, _arraysData$indexonSc22, _arraysData$indexonSc23, _arraysData$indexonSc24, _arraysData$indexonSc25, _arraysData$indexonSc26, _arraysData$indexonSc27, _arraysData$indexonSc28, _arraysData$indexonSc29, _arraysData$indexonSc30, _arraysData$indexonSc31, _arraysData$indexonSc32, _arraysData$indexonSc33, _arraysData$indexonSc34, _arraysData$indexonSc35, _arraysData$indexonSc36, _arraysData$indexonSc37, _arraysData$indexonSc38, _arraysData$indexonSc39, _arraysData$indexonSc40, _arraysData$indexonSc41, _arraysData$indexonSc42, _pointsData$standings, _pointsData$standings2, _trendingData$entitie, _postData$seoData, _postData$seoData2, _postData$seoData3, _postData$seoData4, _postData$seoData5, _postData$seoData6, _postData$seoData7, _postData$seoData8, _postData$seoData9, _postData$additionalS, _postData$additionalS2;

  var postData = _ref.postData,
      _ref$postType = _ref.postType,
      postType = _ref$postType === void 0 ? "" : _ref$postType,
      _ref$prevUrl = _ref.prevUrl,
      prevUrl = _ref$prevUrl === void 0 ? "" : _ref$prevUrl,
      _ref$trendingData = _ref.trendingData,
      trendingData = _ref$trendingData === void 0 ? "" : _ref$trendingData,
      _ref$articlePageBanne = _ref.articlePageBanners,
      articlePageBanners = _ref$articlePageBanne === void 0 ? [] : _ref$articlePageBanne,
      _ref$homePageVideos = _ref.homePageVideos,
      homePageVideos = _ref$homePageVideos === void 0 ? [] : _ref$homePageVideos,
      categoryName = _ref.categoryName,
      pointsData = _ref.pointsData,
      scoreData = _ref.scoreData,
      cricketTopicData = _ref.cricketTopicData;
  // console.log("received", {
  //   postData,
  //   postType,
  //   prevUrl,
  //   trendingData,
  //   // cricketResponse = [],
  //   articlePageBanners,
  //   // electionTopicData = [],
  //   homePageVideos,
  //   categoryName,
  //   pointsData,
  //   scoreData,
  //   cricketTopicData
  // })
  var shortsCards;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(true),
      showStickyBanner = _useState[0],
      setShowStickyBanner = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      callRosBottom = _useState2[0],
      setCallRosBottom = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      pageScrolled = _useState3[0],
      setPageScrolled = _useState3[1]; // const [publicRuntimeConfig, setPublicRunTimeConfig] = useState({
  //   electionExitPollToggle: false,
  //   electionResultToggle: true,
  //   vidhansabhaResultToggle: true,
  //   resultVersion: 1.6,
  //   exitPollVersion: 1.2,
  //   electionYear: 2024,
  //   isElectionAlpha: true,
  //   keyCandidate: true,
  // });
  // useEffect(() => {
  //   if (typeof window !== "undefined") {
  //     // const remoteConfig = getRemoteConfig(app);
  //     // remoteConfig.settings.minimumFetchIntervalMillis = 3600000;
  //     // fetchAndActivate(remoteConfig)
  //     //   .then(() => {
  //     //     // const titleData = getString(remoteConfig, "electionKeys");
  //     //     // const parsedData = JSON.parse(titleData);
  //     //     // setPublicRunTimeConfig(parsedData);
  //     //     // console.log("Election Keys are ", parsedData);
  //     //     // setVideoUrl(titleData);
  //     //   })
  //     //   .catch((err) => {
  //     //     console.error(err);
  //     //   });
  //   }
  // }, []);


  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)(); // const { query } = router;

  var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useRef)(); // const jwRef = useRef();
  // const isJWVisible = useIsVisible(jwRef);

  var size = (0,api_commonConstants__WEBPACK_IMPORTED_MODULE_9__/* .useWindowSize */ .iP)();

  var _useSession = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_1__.useSession)(),
      session = _useSession.data;

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      loginPrompt = _useState4[0],
      setLoginPrompt = _useState4[1]; // const [videoUrl, setVideoUrl] = useState("");


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      showModal = _useState5[0],
      setShowModal = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      postStateData = _useState6[0],
      setPostStateData = _useState6[1]; // const [liked, setLiked] = useState(false);


  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""),
      language = _useState7[0],
      setLanguage = _useState7[1]; // const [countLike, setCountLike] = useState(postData?.likeCount);


  var _useState8 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("large"),
      fontSize = _useState8[0],
      setFontSize = _useState8[1];

  var _useState9 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      openShareModal = _useState9[0],
      setOpenShareModal = _useState9[1];

  var _useState10 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({}),
      shareData = _useState10[0],
      setShareData = _useState10[1];

  var _useState11 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      loginShow = _useState11[0],
      setLoginShow = _useState11[1]; // const [isElection, setIsElection] = useState(false);
  // const [loadPlayer, setLoadPlayer] = useState(false);
  // const [showButton, setShowButton] = useState(false);


  var _useState12 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null),
      scrollDirection = _useState12[0],
      setScrollDirection = _useState12[1];

  var _useState13 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      isFirstTime = _useState13[0],
      setIsFirstTime = _useState13[1];

  var _useState14 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([postData]),
      arraysData = _useState14[0],
      setArraysData = _useState14[1];

  var _useState15 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0),
      indexonScreen = _useState15[0],
      setIndexOnScreen = _useState15[1]; // const [currentPlayer, setCurrentPlayer] = useState("jw-player-1");
  // const [displayMore, setDisplayMore] = useState(false);


  var _useState16 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([true, false, false, false, false]),
      showMore = _useState16[0],
      setShowMore = _useState16[1]; // const [hideAppButton, setHideAppButton] = useState(false);


  var _useState17 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([postData === null || postData === void 0 ? void 0 : postData.isLiked]),
      infiniteLikeState = _useState17[0],
      setInfiniteLikeState = _useState17[1];

  var _useState18 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([postData === null || postData === void 0 ? void 0 : postData.isBookmarked]),
      infiniteBookmarkState = _useState18[0],
      setInfiniteBookmarkState = _useState18[1];

  var _useState19 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      relatedArticles = _useState19[0],
      setRelatedArticles = _useState19[1];

  var _useState20 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      articleChanges = _useState20[0],
      setArticleChanges = _useState20[1];

  var _useState21 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      adCalled = _useState21[0],
      setAdCalled = _useState21[1]; // console.log("relatedArticles are ", relatedArticles, postData);


  var _useSelector = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function (_ref2) {
    var AuthReducer = _ref2.AuthReducer;
    return AuthReducer;
  }),
      userLocalDetail = _useSelector.userLocalDetail;

  var _useSelector2 = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useSelector */ .v9)(function (_ref3) {
    var PostReducer = _ref3.PostReducer;
    return PostReducer;
  }),
      postDetails = _useSelector2.postDetails;

  var _useState22 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]),
      bookmarkArticleArray = _useState22[0],
      setBookmkarkArticleArray = _useState22[1];

  var masterConfigCT = (0,react__WEBPACK_IMPORTED_MODULE_6__.useContext)(constants_MasterConfigContext__WEBPACK_IMPORTED_MODULE_18__/* .MasterConfigContext */ .d); // const { trendingPosts } = useSelector(({ PostReducer }) => PostReducer);
  // const { mobilePopUp } = useSelector(({ AuthReducer }) => AuthReducer);
  // const { statistics } = useSelector(({ PostReducer }) => PostReducer);

  var testArray = [];
  var contentContainer; // console.log("arraysData postdata", arraysData);

  var _useState23 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([postData === null || postData === void 0 ? void 0 : postData._id]),
      bookmarkArray = _useState23[0],
      setBookmarkArray = _useState23[1];

  var _useState24 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      firstScroll = _useState24[0],
      setFirstScroll = _useState24[1];

  var _useState25 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false),
      playerReady = _useState25[0],
      setPlayerReady = _useState25[1];

  var sendGAEvent = function sendGAEvent(label, value) {
    if (typeof window.gtag !== "undefined") {
      window.gtag("event", "Native_Video", {
        send_to: "G-RXRPKR4310",
        eventCategory: "Main_Video",
        eventLabel: label,
        eventValue: value
      });
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    // Dispatch on mount
    if (postData !== null && postData !== void 0 && postData.seriesId) {
      dispatch((0,redux_actions_seriesAction__WEBPACK_IMPORTED_MODULE_21__/* .setVideoIsShow */ .CO)(true));
    } else {
      dispatch((0,redux_actions_seriesAction__WEBPACK_IMPORTED_MODULE_21__/* .setVideoIsShow */ .CO)(false));
    } // Dispatch on unmount


    return function () {
      dispatch((0,redux_actions_seriesAction__WEBPACK_IMPORTED_MODULE_21__/* .setVideoIsShow */ .CO)(false));
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    function onFirstScroll() {
      return _onFirstScroll.apply(this, arguments);
    }

    function _onFirstScroll() {
      _onFirstScroll = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!firstScroll) {
                  runScripts();
                  setFirstScroll(true);
                  fetchRelatedArticles(postData._id); // Taboola Start

                  window._taboola = window._taboola || [];

                  _taboola.push({
                    article: "auto"
                  });

                  !function (e, f, u, i) {
                    if (!document.getElementById(i)) {
                      e.async = 1;
                      e.src = u;
                      e.id = i;
                      f.parentNode.insertBefore(e, f);
                    }
                  }(document.createElement("script"), document.getElementsByTagName("script")[0], "//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js", "tb_loader_script");

                  if (window.performance && typeof window.performance.mark == "function") {
                    window.performance.mark("tbl_ic");
                  }

                  window._taboola = window._taboola || [];

                  _taboola.push({
                    mode: "alternating-thumbnails-a",
                    container: "taboola-below-article-thumbnails",
                    placement: "Below Article Thumbnails",
                    target_type: "mix"
                  }); // Taboola End

                }

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _onFirstScroll.apply(this, arguments);
    }

    function handleScroll() {
      onFirstScroll();
      window.removeEventListener("scroll", handleScroll);
    }

    window.addEventListener("scroll", handleScroll);

    var checkJWPlayerReady = function checkJWPlayerReady() {
      var attempt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (window.jwplayer && typeof window.jwplayer === "function") {
        setPlayerReady(true);
      } else if (attempt < 6) {
        setTimeout(function () {
          return checkJWPlayerReady(attempt + 1);
        }, 200); // Retry every 200ms
      }
    };

    var loadJWPlayer = function loadJWPlayer() {
      return new Promise(function (resolve) {
        if (window.jwplayer) {
          resolve();
        } else {
          var script = document.createElement("script");
          script.src = "https://cdn.jwplayer.com/libraries/gtSITKWv.js"; // script.async = true;

          script.onload = function () {
            return checkJWPlayerReady();
          };

          script.defer = true; // Load after critical elements

          document.body.appendChild(script);
        }
      });
    };

    loadJWPlayer().then(function () {
      setPlayerReady(true);
    }); // const { jwplayer } = window;
    // if (jwplayer) {
    //   // console.log("Player exists in dom");
    //   // delete window.jwplayer;
    //   var script = document.createElement("script");
    //   script.src = "https://cdn.jwplayer.com/libraries/gtSITKWv.js";
    //   // Execute callback once the script has finished loading
    //   script.onload = () => {
    //     // console.log("Script loaded");
    //     setLoadPlayer(true);
    //   };
    //   // Append the script tag to the document's head
    //   document.head.appendChild(script);
    // } else {
    //   setLoadPlayer(true);
    //   // console.log("Player does not exists in dom");
    // }
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (playerReady && window.jwplayer) {
      var _navigator$connection, _navigator$connection2;

      var isSlowNetwork = ["2g", "3g"].includes((_navigator$connection = navigator.connection) === null || _navigator$connection === void 0 ? void 0 : _navigator$connection.effectiveType) || ((_navigator$connection2 = navigator.connection) === null || _navigator$connection2 === void 0 ? void 0 : _navigator$connection2.saveData);
      var playerId = "jwplayer-container-".concat(indexonScreen);
      var playerInstance = window.jwplayer("".concat(playerId)).setup({
        file: arraysData[indexonScreen].assetFileLink,
        image: "".concat(arraysData[indexonScreen].headingImageUrl, "?q=50&width=720"),
        width: "100%",
        aspectratio: "16:9",
        // Maintain 16:9 aspect ratio
        autostart: indexonScreen == 0 && !isSlowNetwork ? "viewable" : false,
        // Start only when visible
        mute: true,
        preload: isSlowNetwork ? "none" : "metadata" // Loads only metadata first, not the full video

      });
      window.activeJWPlayers = window.activeJWPlayers || []; // Attach event listeners

      playerInstance.on("play", function () {
        // Pause all other active players before playing the new one
        window.activeJWPlayers.forEach(function (id) {
          var _window$jwplayer;

          if (id !== playerId && ((_window$jwplayer = window.jwplayer(id)) === null || _window$jwplayer === void 0 ? void 0 : _window$jwplayer.getState()) === "playing") {
            window.jwplayer(id).pause();
            window.jwplayer(id).setFloating(false);
          }
        }); // Add new player to active list

        if (!window.activeJWPlayers.includes(playerId)) {
          window.activeJWPlayers.push(playerId);
        }

        sendGAEvent("Video Starts", arraysData[indexonScreen].englishTitle);
      });
      playerInstance.on("pause", function () {
        sendGAEvent("Video Paused", arraysData[indexonScreen].englishTitle);
      });
      playerInstance.on("seek", function (event) {
        sendGAEvent("Video Seeked", "Seeked_to_".concat(event.offset));
      });
      playerInstance.on("time", function (event) {
        var percentage = event.position / event.duration * 100;
        if (percentage >= 25 && percentage < 30) sendGAEvent("Video Duration", "Duration_25%");
        if (percentage >= 50 && percentage < 55) sendGAEvent("Video Duration", "Duration_50%");
        if (percentage >= 75 && percentage < 80) sendGAEvent("Video Duration", "Duration_75%");
        if (percentage >= 100) sendGAEvent("Video Duration", "Duration_100%");
      });
    }
  }, [playerReady, indexonScreen]);
  var authorName = postData === null || postData === void 0 ? void 0 : (_postData$createdByEm = postData.createdByEmail) === null || _postData$createdByEm === void 0 ? void 0 : _postData$createdByEm.split("@")[0];

  var _useState26 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0),
      relatedWidth = _useState26[0],
      setRelatedWidth = _useState26[1];

  var mainUrl = "all";

  var handleCustomBack = function handleCustomBack() {
    if (prevUrl && articleChanges || !prevUrl.includes("post")) {
      router.push(prevUrl);
    } else {
      location.replace("/");
    }
  };

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    window.addEventListener("popstate", handleCustomBack);
    return function () {
      window.removeEventListener("popstate", handleCustomBack);
    };
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var jw_script = document.getElementById("__jw-ld-json");

    if (jw_script) {
      jw_script.parentNode.removeChild(jw_script);
    }
  });
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var _document, _document2, _shortsCards, _shortsCards2;

    shortsCards = (_document = document) === null || _document === void 0 ? void 0 : _document.querySelectorAll(".infinite");
    contentContainer = (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.getElementsByClassName(".content-container")[0];
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // console.log("entries", entry);
        if (entry.isIntersecting) {
          setArticleChanges(true);
          var index = parseInt(entry.target.className.split(" ")[2]);
          setIndexOnScreen(index);
          testArray.push(index); // console.log("index on screen  is", index, entry.target.className);

          if (index === 0 && testArray.length > 1 || index !== 0) {
            setTimeout(function () {
              if (typeof googletag.pubads === "function") {
                // console.log("Refresh fired");
                googletag.pubads().refresh();
              }
            }, 500);
          }
        } else {
          var index = parseInt(entry.target.className.split(" ")[2]); // console.log("In observer going out of screen index", index);
        }
      });
    }, {
      threshold: 0.3,
      root: contentContainer
    });
    ((_shortsCards = shortsCards) === null || _shortsCards === void 0 ? void 0 : _shortsCards.length) > 0 && ((_shortsCards2 = shortsCards) === null || _shortsCards2 === void 0 ? void 0 : _shortsCards2.forEach(function (entry) {
      // console.log("In observer each", entry);
      observer.observe(entry);
    }));
  }, [arraysData]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    // Function to handle the intersection event of the first article
    var onIntersection = function onIntersection(entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // console.log("Comments section is in view!");
          setIndexOnScreen(0);
        } else {// console.log("Comments section is not in view!");
        }
      });
    };

    var observer = new IntersectionObserver(onIntersection, {
      root: null,
      // Observe in the viewport
      rootMargin: "0px",
      // No margin
      threshold: 0.5 // 50% of the element must be visible

    }); // Get the comments section element

    var commentsSection = document.querySelector(".first-article-observer"); // Start observing the comments section

    observer.observe(commentsSection);
  }, [arraysData]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (articleChanges) {
      changeUrl();
    }
  }, [indexonScreen]); // useEffect(() => {
  //   const { jwplayer } = window;
  //   if (jwplayer) {
  //     // console.log("Player exists in dom");
  //     // delete window.jwplayer;
  //     var script = document.createElement("script");
  //     script.src = "https://cdn.jwplayer.com/libraries/gtSITKWv.js";
  //     // Execute callback once the script has finished loading
  //     script.onload = () => {
  //       // console.log("Script loaded");
  //       setLoadPlayer(true);
  //     };
  //     // Append the script tag to the document's head
  //     document.head.appendChild(script);
  //   } else {
  //     setLoadPlayer(true);
  //     // console.log("Player does not exists in dom");
  //   }
  // }, []);
  // useEffect(() => {
  //   console.log("isFirstTime", isFirstTime);
  // }, [isFirstTime]);

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var lastScrollY = window.pageYOffset;
    var animationFrameId;
    var scrollingTimeout;

    var updateScrollDirection = function updateScrollDirection() {
      // setHideAppButton(true);
      setIsFirstTime(false);
      clearTimeout(scrollingTimeout);
      cancelAnimationFrame(animationFrameId);
      setCallRosBottom(true);
      setPageScrolled(true);
      animationFrameId = requestAnimationFrame(function () {
        scrollingTimeout = setTimeout(function () {// setHideAppButton(false);
        }, 700);
      });
      var scrollY = window.screenY;
      var direction = scrollY > lastScrollY ? "down" : "up";

      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);

        if (isFirstTime) {
          setIsFirstTime(false);
        }
      }

      lastScrollY = scrollY > 0 ? scrollY : 0;
    };

    window.addEventListener("scroll", updateScrollDirection); // add event listener

    return function () {
      window.removeEventListener("scroll", updateScrollDirection);
    };
  }, [scrollDirection, isFirstTime]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    runChartBeatScript();
  }, [indexonScreen]); // useEffect(() => {
  //   if (!isFirstTime) {
  //     runScripts();
  //     // fetchRelatedArticles(postData._id);
  //   }
  // }, [isFirstTime]);

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    setTimeout(function () {
      if (typeof window.gtag !== "undefined") {
        gtag("create", "G-RXRPKR4310", "auto");

        if ((postData === null || postData === void 0 ? void 0 : postData.type) === "text") {
          var page_article_data_video = {};
          page_article_data_video["send_to"] = "G-RXRPKR4310";
          page_article_data_video["eventCategory"] = "Article Pages";
          page_article_data_video["eventLabel"] = "page_view_".concat(postData.englishTitle);
          page_article_data_video["eventValue"] = "".concat(postData.permalink);
          gtag("event", "article_page_view", page_article_data_video);
        } else {
          var page_article_data = {};
          page_article_data["send_to"] = "G-RXRPKR4310";
          page_article_data["eventCategory"] = "Video Pages";
          page_article_data["eventLabel"] = "page_view_".concat(postData.englishTitle);
          page_article_data["eventValue"] = "".concat(postData.permalink);
          gtag("event", "video_page_view", page_article_data);
        }
      } // fetchRelatedArticles(postData._id);

    }, 1500);
  }, [isFirstTime]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if ((relatedArticles === null || relatedArticles === void 0 ? void 0 : relatedArticles.length) > 0) {
      fetchArticleData();
    }
  }, [relatedArticles]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    setPostStateData(postData); // if (postData) {
    //   setLiked(postData?.isLiked);
    // }
  }, [postData]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (postData !== null && postData !== void 0 && postData.postId ? (postDetails === null || postDetails === void 0 ? void 0 : postDetails._id) === (postData === null || postData === void 0 ? void 0 : postData.postId) : (postDetails === null || postDetails === void 0 ? void 0 : postDetails._id) === (postData === null || postData === void 0 ? void 0 : postData._id)) {
      setPostStateData(postDetails); // setLiked(postDetails?.isLiked);
      // setCountLike(postDetails?.likeCount);
    }
  }, [postDetails, postData === null || postData === void 0 ? void 0 : postData._id, postData === null || postData === void 0 ? void 0 : postData.postId]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    (0,utils_deviceIdGenerator__WEBPACK_IMPORTED_MODULE_13__/* .GenerateUniqId */ .N)().then(function (deviceId) {
      var viewObj = {
        postId: postData._id,
        deviceType: "web",
        deviceId: deviceId
      };
      dispatch((0,redux_actions_postAction__WEBPACK_IMPORTED_MODULE_23__/* .storyView */ .Kw)(viewObj, postType));
    });
  }, [postData === null || postData === void 0 ? void 0 : postData._id, postType, dispatch]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    setLanguage((0,localization_i8intl__WEBPACK_IMPORTED_MODULE_12__/* .getLanguage */ .G3)());
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    dispatch((0,redux_actions_ads_Actions__WEBPACK_IMPORTED_MODULE_24__/* .getAdsBySize */ .R)());
  }, [dispatch]); // function handleCommentClick() {
  //   const showMoreButton = document.querySelector(".tbl-read-more-btn ");
  //   if (showMoreButton) {
  //     showMoreButton.click();
  //   }
  //   if (ref.current) {
  //     ref.current.scrollIntoView({ behavior: "smooth" });
  //   }
  // }
  // useEffect(() => {
  //   if (postData?.assetFileLink?.includes("video.m3u8")) {
  //     let file = postData?.assetFileLink?.replace("video.m3u8", "video.mp4");
  //     setVideoUrl(file);
  //   } else if (postData?.assetFileLink?.includes("master.m3u8")) {
  //     let file1 = postData?.assetFileLink?.replace("master.m3u8", "video.mp4");
  //     setVideoUrl(file1);
  //   } else {
  //     let file2 = postData?.assetFileLink;
  //     setVideoUrl(file2);
  //   }
  // }, [postData]);

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (window && typeof window.localStorage !== "undefined") {
      var fs = window.localStorage.getItem("fontSize");

      if (fs && ["small", "normal", "large"].includes(fs)) {
        setFontSize(fs);
      }
    }
  }, [fontSize]); // useEffect(() => {
  //   if (router.asPath.includes("/sports")) {
  //     const script = document.createElement("script");
  //     script.innerHTML = `
  //     window._izq = window._izq || [];
  //     window._izq.push(["userProfile", {
  //       "add": {
  //         "Category": "Sports"
  //       }
  //     }]);
  //   `;
  //     script.defer = true;
  //     document.head.appendChild(script);
  //   }
  //   return () => {
  //     document.head.removeChild(script); // Cleanup when component unmounts
  //   };
  // }, []);
  // const handleLike = (postObj, postDetails, index) => {
  //   if (userLocalDetail?.id || session?.user?.email) {
  //     dispatch(postLike(postObj, postType, postDetails));
  //     let alteredLikeArr = [...infiniteLikeState];
  //     alteredLikeArr[index] = !infiniteLikeState[index];
  //     setInfiniteLikeState(alteredLikeArr);
  //   } else {
  //     setLoginShow(true);
  //   }
  // };

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var _session$user;

    if (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user = session.user) !== null && _session$user !== void 0 && _session$user.email) {
      dispatch((0,redux_actions_postAction__WEBPACK_IMPORTED_MODULE_23__/* .getStats */ .fy)(postData === null || postData === void 0 ? void 0 : postData._id));
    }
  }, []); // const handleClose = () => {
  //   setShowButton((e) => !e);
  // };

  var handleBookmark = function handleBookmark(_id, type, index) {
    var _session$user2;

    if (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user2 = session.user) !== null && _session$user2 !== void 0 && _session$user2.email) {
      var _bookmarkArticleArray;

      var postObj = {
        table: "post",
        postId: _id,
        type: type
      };
      dispatch((0,redux_actions_bookmarksActions__WEBPACK_IMPORTED_MODULE_25__/* .saveBookmark */ .Bn)(postObj));

      var alteredBookArr = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(infiniteBookmarkState);

      alteredBookArr[index] = !infiniteBookmarkState[index];
      setInfiniteBookmarkState(alteredBookArr); //setShowDropdown((e) => !e);

      bookmarkArticleArray[index].isBookmarked = (_bookmarkArticleArray = bookmarkArticleArray[index]) !== null && _bookmarkArticleArray !== void 0 && _bookmarkArticleArray.isBookmarked ? false : true;
    } else {
      if (setLoginShow) setLoginShow(true);
    }
  };

  var handleShare = function handleShare(articleData) {
    var share = {
      title: articleData === null || articleData === void 0 ? void 0 : articleData.title,
      text: articleData === null || articleData === void 0 ? void 0 : articleData.title
    }; //if (shareUrl) share.url = shareUrl;

    share.url = (articleData === null || articleData === void 0 ? void 0 : articleData.permalink) + "?utm_source=Internal_LT&utm_medium=".concat(postData === null || postData === void 0 ? void 0 : postData.type, "&utm_name=system-share"); //console.log("share: ", share);

    setShareData(share);

    if (!navigator || !navigator.share) {
      setOpenShareModal(true); // console.log("Platform not supported!");
    } else {
      utils_uiHelper__WEBPACK_IMPORTED_MODULE_15__/* ["default"].share */ .Z.share(share);
    }
  };

  var changeUrl = function changeUrl() {
    if (indexonScreen === 0) {
      var currentURL = window.location.href;
      var count = 0;
      var baseURl = "";

      (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(currentURL).forEach(function (c) {
        if (c === "/") {
          count++;
        }

        if (count < 3) {
          baseURl += c;
        }
      });

      baseURl = baseURl + "/" + arraysData[0].categorySlug + "/video/" + arraysData[0].postSlug;
      window.history.pushState({}, document.title, baseURl);
    } else {
      var _arraysData$indexonSc, _arraysData$indexonSc2, _arraysData$indexonSc3, _arraysData$indexonSc4, _arraysData$indexonSc5;

      var currentURL = window.location.href;
      var _count = 0;
      var _baseURl = "";

      (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(currentURL).forEach(function (c) {
        if (c === "/") {
          _count++;
        }

        if (_count < 3) {
          _baseURl += c;
        }
      });

      _baseURl = _baseURl + "/" + ((_arraysData$indexonSc = arraysData[indexonScreen]) === null || _arraysData$indexonSc === void 0 ? void 0 : _arraysData$indexonSc.categorySlug) + "/video/" + ((_arraysData$indexonSc2 = arraysData[indexonScreen]) === null || _arraysData$indexonSc2 === void 0 ? void 0 : _arraysData$indexonSc2.postSlug);
      var obj = {
        eventName: "Infinite_Scroll",
        pageTitle: "Article Detail",
        propertyObject: {
          title: (_arraysData$indexonSc3 = arraysData[indexonScreen]) === null || _arraysData$indexonSc3 === void 0 ? void 0 : (_arraysData$indexonSc4 = _arraysData$indexonSc3.seoData) === null || _arraysData$indexonSc4 === void 0 ? void 0 : _arraysData$indexonSc4.metaTitle,
          id: (_arraysData$indexonSc5 = arraysData[indexonScreen]) === null || _arraysData$indexonSc5 === void 0 ? void 0 : _arraysData$indexonSc5._id,
          position: indexonScreen + 1
        }
      };
      (0,constants_cricket__WEBPACK_IMPORTED_MODULE_19__/* .callGaEvent */ .ut)(obj);
      window.history.pushState({}, document.title, _baseURl);
      window._comscore = window._comscore || []; // Push Comscore configuration

      window._comscore.push({
        c1: "2",
        c2: "8549097",
        cs_ucfr: 0,
        options: {
          enableFirstPartyCookie: true
        }
      }); // Create <script> element


      var script = document.createElement("script");
      script.async = true;
      script.src = "https://sb.scorecardresearch.com/cs/8549097/beacon.js"; // Find the first script element on the page

      var firstScript = document.getElementsByTagName("script")[0]; // Insert the new script before the first script element

      firstScript.parentNode.insertBefore(script, firstScript);
      apstag.fetchBids({
        slots: size.width < 768 ? (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .createApsSlotsRosMobile */ .PI)({}) : (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .createApsSlotsRosDesktop */ .VG)({}),
        timeout: 2e3
      }, _Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .apstagBidCallback */ .O8);
      var script2 = document.createElement('script');
      script2.type = 'text/javascript';
      script2.async = true;
      script2.src = "//pb-script-03.ccgateway.net/script?id=cca&parentId=" + window.location.hostname; // Append the script to the document
      // document.body.appendChild(script);

      document.body.appendChild(script2);
    }
  }; // const handleVideoPlay = async (currentId) => {
  //   if (window !== undefined) {
  //     const { jwplayer } = window;
  //     if (jwplayer && currentPlayer !== currentId) {
  //       // jwplayer(currentId).setFloating(true)
  //       jwplayer(currentPlayer).pause();
  //       jwplayer(currentPlayer).setFloating(false);
  //     } else {
  //       // console.log("jwplayer not found or same player");
  //     }
  //   }
  // };


  function shareLinkToWhatsApp(articleData) {
    var _arraysData$indexonSc6, _arraysData$indexonSc7, _arraysData$indexonSc8;

    var share = {
      title: (_arraysData$indexonSc6 = arraysData[indexonScreen]) === null || _arraysData$indexonSc6 === void 0 ? void 0 : _arraysData$indexonSc6.title,
      text: (_arraysData$indexonSc7 = arraysData[indexonScreen]) === null || _arraysData$indexonSc7 === void 0 ? void 0 : _arraysData$indexonSc7.title
    }; //if (shareUrl) share.url = shareUrl;

    share.url = ((_arraysData$indexonSc8 = arraysData[indexonScreen]) === null || _arraysData$indexonSc8 === void 0 ? void 0 : _arraysData$indexonSc8.permalink) + "?utm_source=Internal_LT&utm_medium=".concat(postData === null || postData === void 0 ? void 0 : postData.type, "&utm_name=whatsapp-share");
    var whatsappLink = "whatsapp://send?text=".concat(encodeURIComponent("".concat(share.title, " ").concat(share.url)));
    window.location.href = whatsappLink;
  }

  var keywords = arraysData[indexonScreen] && arraysData[indexonScreen].altTags ? arraysData[indexonScreen].altTags.toString() : "";
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    // console.log("Calling ads");
    var showAds = true;

    if (false) {}

    if (showAds && !adCalled) {
      setAdCalled(true);
      setTimeout(function () {
        // console.log("showAds", showAds, process.env.NEXT_PUBLIC_ADS_ONSCROLL);
        window.googletag = window.googletag || {
          cmd: []
        };

        if (window.screen.width > 600) {
          googletag.cmd.push(function () {
            var _removeEmbeds, _removeEmbeds$split;

            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_728x90", [[728, 90], [970, 250], [970, 90]], "div-gpt-ad-1701945163318-0").addService(googletag.pubads());
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_ATF_300x250", [300, 250], "div-gpt-ad-1701945220410-0").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Desktop_ROS_MTF_1_728x90",
            //     [728, 90],
            //     "div-gpt-ad-1701945220410-1"
            //   )
            //   .addService(googletag.pubads());

            if (((_removeEmbeds = (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .removeEmbeds */ .q3)(postData === null || postData === void 0 ? void 0 : postData.articleHTML)) === null || _removeEmbeds === void 0 ? void 0 : (_removeEmbeds$split = _removeEmbeds.split("</p>")) === null || _removeEmbeds$split === void 0 ? void 0 : _removeEmbeds$split.length) >= 4) {
              googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_2_728x90", [728, 90], "div-gpt-ad-1701945220410-2").addService(googletag.pubads());
            }

            if ((postData === null || postData === void 0 ? void 0 : postData.type) === "text") {
              googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_3_728x90", [728, 90], "div-gpt-ad-1701945220410-3").addService(googletag.pubads());
            }

            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_BTF_300x250", [[300, 250], [300, 600]], "div-gpt-ad-1701945864013-0").addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "".concat(categoryName, ",video,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
            googletag.pubads().setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .requestBiddingFromPWT */ .WX)();
          });
        } else {
          googletag.cmd.push(function () {
            var _removeEmbeds2, _removeEmbeds2$split;

            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_ATF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-0").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_ROS_MTF_1_300x250",
            //     [
            //       [336, 280],
            //       [300, 250],
            //     ],
            //     "div-gpt-ad-1701946028239-1"
            //   )
            //   .addService(googletag.pubads());

            if (((_removeEmbeds2 = (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .removeEmbeds */ .q3)(postData === null || postData === void 0 ? void 0 : postData.articleHTML)) === null || _removeEmbeds2 === void 0 ? void 0 : (_removeEmbeds2$split = _removeEmbeds2.split("</p>")) === null || _removeEmbeds2$split === void 0 ? void 0 : _removeEmbeds2$split.length) >= 4) {
              googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_2_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-2").addService(googletag.pubads());
            }

            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_BTF_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-3").addService(googletag.pubads()); // googletag
            //   .defineSlot(
            //     "/1007232/Lallantop_Mobile_ROS_Bottom_320x50",
            //     [320, 50],
            //     "div-gpt-ad-1701946324333-0"
            //   )
            //   .addService(googletag.pubads());

            googletag.defineOutOfPageSlot("/1007232/Lallantop_Mobile_ROS_Mweb_Interstitial", googletag.enums.OutOfPageFormat.INTERSTITIAL).addService(googletag.pubads());
            googletag.pubads().enableSingleRequest();
            googletag.pubads().setTargeting("Category", "".concat(categoryName, ",video,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
            googletag.pubads().setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .requestBiddingFromPWT */ .WX)();
          });
        } // apstag.fetchBids(
        //   {
        //     slots:
        //       size?.width < 499
        //         ? createApsSlotsRosMobile({})
        //         : createApsSlotsRosDesktop({}),
        //     timeout: 2e3,
        //   },
        //   apstagBidCallback
        // );

      }, 500);
    }
  }, [postData, isFirstTime]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (pageScrolled) {
      setTimeout(function () {
        window.googletag = window.googletag || {
          cmd: []
        };

        if (window.screen.width > 600) {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Desktop_ROS_MTF_1_728x90", [728, 90], "div-gpt-ad-1701945220410-1").addService(googletag.pubads()); // if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
            //   googletag
            //     .defineSlot(
            //       "/1007232/Lallantop_Desktop_ROS_MTF_2_728x90",
            //       [728, 90],
            //       "div-gpt-ad-1701945220410-2"
            //     )
            //     .addService(googletag.pubads());
            // }
            // googletag.pubads().enableSingleRequest();

            googletag.pubads().setTargeting("Category", "".concat(categoryName, ",video,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
            googletag.pubads().setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .requestBiddingFromPWT */ .WX)();
            googletag.pubads().refresh();
          });
        } else {
          googletag.cmd.push(function () {
            googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_MTF_1_300x250", [[336, 280], [300, 250]], "div-gpt-ad-1701946028239-1").addService(googletag.pubads()); // if (removeEmbeds(postData?.articleHTML).split("</p>").length >= 4) {
            //   googletag
            //     .defineSlot(
            //       "/1007232/Lallantop_Mobile_ROS_MTF_2_300x250",
            //       [
            //         [336, 280],
            //         [300, 250],
            //       ],
            //       "div-gpt-ad-1701946028239-2"
            //     )
            //     .addService(googletag.pubads());
            // }
            // googletag.pubads().enableSingleRequest();

            googletag.pubads().setTargeting("Category", "".concat(categoryName, ",video,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
            googletag.pubads().setTargeting("Keywords", keywords);
            googletag.pubads().disableInitialLoad();
            googletag.enableServices();
            (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .requestBiddingFromPWT */ .WX)();
            googletag.pubads().refresh();
          });
        }
      }, 500);
    }
  }, [pageScrolled]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (callRosBottom) {
      window.googletag = window.googletag || {
        cmd: []
      };

      if (window.screen.width <= 600) {
        googletag.cmd.push(function () {
          googletag.defineSlot("/1007232/Lallantop_Mobile_ROS_Bottom_320x50", [320, 50], "div-gpt-ad-1701946324333-0").addService(googletag.pubads());
          googletag.pubads().enableSingleRequest();
          googletag.pubads().setTargeting("Category", "".concat(categoryName, ",video,").concat(postData === null || postData === void 0 ? void 0 : postData._id));
          googletag.pubads().setTargeting("Keywords", keywords);
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .requestBiddingFromPWT */ .WX)();
        });
      }
    }
  }, [callRosBottom]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (size.width) {
      apstag.fetchBids({
        slots: size.width < 768 ? (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .createApsSlotsRosMobile */ .PI)({}) : (0,_Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .createApsSlotsRosDesktop */ .VG)({}),
        timeout: 2e3
      }, _Ads_index__WEBPACK_IMPORTED_MODULE_17__/* .apstagBidCallback */ .O8);
    }
  }, [size.width]);

  var runChartBeatScript = function runChartBeatScript() {
    (function () {
      var _arraysData$indexonSc9, _arraysData$indexonSc10, _arraysData$indexonSc11, _arraysData$indexonSc12;

      /* CONFIGURATION START */
      var _sf_async_config = window._sf_async_config = window._sf_async_config || {};

      _sf_async_config.uid = 60355;
      _sf_async_config.domain = "thelallantop.com";
      _sf_async_config.useCanonical = true;
      _sf_async_config.useCanonicalDomain = true;
      _sf_async_config.sections = "".concat((_arraysData$indexonSc9 = arraysData[indexonScreen]) === null || _arraysData$indexonSc9 === void 0 ? void 0 : _arraysData$indexonSc9.categorySlug);
      _sf_async_config.authors = "".concat((_arraysData$indexonSc10 = arraysData[indexonScreen]) === null || _arraysData$indexonSc10 === void 0 ? void 0 : (_arraysData$indexonSc11 = _arraysData$indexonSc10.contentAuthors[0]) === null || _arraysData$indexonSc11 === void 0 ? void 0 : _arraysData$indexonSc11.fullname);
      _sf_async_config.path = "/".concat((_arraysData$indexonSc12 = arraysData[indexonScreen]) === null || _arraysData$indexonSc12 === void 0 ? void 0 : _arraysData$indexonSc12.categorySlug, "/video/").concat(arraysData[indexonScreen].postSlug);
      /* CONFIGURATION END */

      function loadChartbeat() {
        var e = document.createElement("script");
        var n = document.getElementsByTagName("script")[0];
        e.type = "text/javascript";
        e.async = true;

        if ((postData === null || postData === void 0 ? void 0 : postData.type) === "video") {
          e.src = "//static.chartbeat.com/js/chartbeat_video.js";
        } else {
          e.src = "//static.chartbeat.com/js/chartbeat.js";
        }

        n.parentNode.insertBefore(e, n);
      }

      setTimeout(function () {
        loadChartbeat();
      }, 500);
      loadChartbeat();
      var twitter = document.createElement("script");
      twitter.setAttribute("src", "https://platform.twitter.com/widgets.js");
      twitter.setAttribute("async", "true");
      document.head.appendChild(twitter);
      var reddit = document.createElement("script");
      reddit.setAttribute("src", "https://embed.reddit.com/widgets.js");
      reddit.setAttribute("async", "true");
      document.head.appendChild(reddit);
    })();
  };

  var runScripts = function runScripts() {
    //console.log("Scripts Called");
    if ((postData === null || postData === void 0 ? void 0 : postData.type) !== "video") {
      (function (v, d, o, ai) {
        ai = d.createElement("script");
        ai.defer = true;
        ai.async = true;
        ai.src = v.location.protocol + o;
        d.head.appendChild(ai);
      })(window, document, "//a.vdo.ai/core/v-thelallantop/vdo.ai.js");

      window, document, "//a.vdo.ai/core/v-thelallantop-v1/vdo.ai.js";
    } else {
      (function (v, d, o, ai) {
        ai = d.createElement("script");
        ai.defer = true;
        ai.async = true;
        ai.src = v.location.protocol + o;
        d.head.appendChild(ai);
      })(window, document, "//a.vdo.ai/core/v-thelallantop-v1/vdo.ai.js");
    } // window._taboola = window._taboola || [];
    // _taboola.push({ article: "auto" });
    // !(function (e, f, u, i) {
    //   if (!document.getElementById(i)) {
    //     e.async = 1;
    //     e.src = u;
    //     e.id = i;
    //     f.parentNode.insertBefore(e, f);
    //   }
    // })(
    //   document.createElement("script"),
    //   document.getElementsByTagName("script")[0],
    //   "//cdn.taboola.com/libtrc/indiatoday-thelallantop/loader.js",
    //   "tb_loader_script"
    // );
    // if (window.performance && typeof window.performance.mark == "function") {
    //   window.performance.mark("tbl_ic");
    // }
    // window._taboola = window._taboola || [];
    // _taboola.push({
    //   mode: "alternating-thumbnails-a",
    //   container: "taboola-below-article-thumbnails",
    //   placement: "Below Article Thumbnails",
    //   target_type: "mix",
    // });

  };

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    if (relatedArticles.length > 1) {
      var ar = [];
      relatedArticles.forEach(function (article) {
        ar.push(article === null || article === void 0 ? void 0 : article._id);
      });
      setBookmarkArray([].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(bookmarkArray), ar));
    }
  }, [relatedArticles]);

  var fetchRelatedArticles = /*#__PURE__*/function () {
    var _ref4 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(id) {
      var data, amp, dat;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_27__/* .baseUrlV2 */ .aG, "/web/related-article?_id=").concat(id, "&limit=8&type=video"), {
                headers: {
                  accesstype: "web"
                }
              });

            case 2:
              data = _context2.sent;
              _context2.next = 5;
              return data.json();

            case 5:
              amp = _context2.sent;
              dat = amp === null || amp === void 0 ? void 0 : amp.result;
              setRelatedArticles(dat);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchRelatedArticles(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var _session$user3;

    if (bookmarkArray.length > 1 && (userLocalDetail !== null && userLocalDetail !== void 0 && userLocalDetail.id || session !== null && session !== void 0 && (_session$user3 = session.user) !== null && _session$user3 !== void 0 && _session$user3.email)) {
      var articlesBookmark = [{}, {}, {}, {}, {}];
      bookmarkArray.forEach( /*#__PURE__*/function () {
        var _ref5 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(item, index) {
          var token, axios, res;
          return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  token = (0,constants_loginConstants__WEBPACK_IMPORTED_MODULE_11__/* .getTokenFromCookies */ .$z)(document.cookie);
                  _context3.next = 3;
                  return (0,api_apiInstance__WEBPACK_IMPORTED_MODULE_8__/* .getAuthorizedApi */ .QJ)(token);

                case 3:
                  axios = _context3.sent;
                  _context3.next = 6;
                  return axios.post("".concat("https://api.thelallantop.com", "/v2/web/getStatistics"), {
                    _id: item
                  });

                case 6:
                  res = _context3.sent;
                  articlesBookmark[index] = res.data.result;
                  setBookmkarkArticleArray(articlesBookmark);

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x2, _x3) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, [bookmarkArray]);

  var fetchArticleData = /*#__PURE__*/function () {
    var _ref6 = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)( /*#__PURE__*/_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4() {
      var ar, token, accessToken, headers, x, data, amp, dat, likeArray, bookmarkArray;
      return _app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              // fetchRelatedArticles(postData._id);
              ar = [];
              token = (0,constants_loginConstants__WEBPACK_IMPORTED_MODULE_11__/* .getTokenFromCookies */ .$z)(document.cookie);
              _context4.next = 4;
              return (0,utils_encryption__WEBPACK_IMPORTED_MODULE_14__/* .decryptData */ .o)(token);

            case 4:
              accessToken = _context4.sent;

              if (accessToken) {
                headers = {
                  method: "GET",
                  headers: {
                    "content-type": "application/json",
                    Authorization: "Bearer ".concat(accessToken)
                  }
                };
              } else {
                headers = {
                  method: "GET",
                  headers: {
                    "content-type": "application/json"
                  }
                };
              }

              x = 0;

            case 7:
              if (!(x < 4)) {
                _context4.next = 19;
                break;
              }

              _context4.next = 10;
              return fetch("".concat(api_constants__WEBPACK_IMPORTED_MODULE_27__/* .baseUrlV2 */ .aG, "/web/postDetailsByCategory/").concat(relatedArticles[x].categorySlug, "/").concat(relatedArticles[x].postSlug, "?accessType=web"), headers);

            case 10:
              data = _context4.sent;
              _context4.next = 13;
              return data.json();

            case 13:
              amp = _context4.sent;
              dat = amp === null || amp === void 0 ? void 0 : amp.result;
              ar.push(dat);

            case 16:
              x++;
              _context4.next = 7;
              break;

            case 19:
              if ((arraysData === null || arraysData === void 0 ? void 0 : arraysData.length) > 0) {
                setArraysData([].concat((0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(arraysData), ar));
              }

              likeArray = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(infiniteLikeState);
              bookmarkArray = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(infiniteBookmarkState);
              ar === null || ar === void 0 ? void 0 : ar.forEach(function (article, articleIndex) {
                likeArray.push(article === null || article === void 0 ? void 0 : article.isLiked);
                bookmarkArray.push(article === null || article === void 0 ? void 0 : article.isBookmarked);
              });
              setInfiniteBookmarkState(bookmarkArray);
              setInfiniteLikeState(likeArray);

            case 25:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function fetchArticleData() {
      return _ref6.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {// console.log("arraysData", arraysData);
  }, [arraysData]);

  var handleReadMore = function handleReadMore(showIndex) {
    var newShowArr = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)(showMore);

    newShowArr[showIndex] = true;
    setShowMore(newShowArr);
  }; // const convertToIST = (dateTimeString = "") => {
  //   try {
  //     // Split the datetime string into date and time parts
  //     const [datePart, timePart] = dateTimeString?.split(" ");
  //     // Concatenate the date and time parts with 'T' in between
  //     const isoDateTime = `${datePart}T${timePart}`;
  //     // Append the timezone offset
  //     const isoDateTimeWithOffset = isoDateTime + "+05:30";
  //     return isoDateTimeWithOffset;
  //   } catch (error) {
  //     console.error(error);
  //     return dateTimeString;
  //   }
  // };
  // const handleScroll = () => {
  //   const isScrolling = document.body.scrollHeight > window.innerHeight;
  //   setIsNotScrolling(!isScrolling);
  // };
  // console.log("PostData ", postData);
  // console.log("array of showMore ", showMore);


  function detectDevice() {
    var width = window.innerWidth;
    var height = window.innerHeight;
    var aspectRatio = width / height;

    if (aspectRatio < 1) {
      // Portrait orientation - typically mobile
      if (width <= 768) {
        return "Mobile";
      } else if (width <= 1024) {
        return "Tablet";
      } else {
        return "Large Tablet or Small Monitor";
      }
    } else {
      // Landscape orientation - could be tablet, desktop, or monitor
      if (width <= 1024) {
        return "Tablet";
      } else if (width <= 1440) {
        return "Desktop";
      } else {
        return "Large Monitor";
      }
    }
  }

  var _useState27 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("Mobile"),
      currentDevice = _useState27[0],
      setDevice = _useState27[1];

  var aspectRatio = size.width > size.height ? size.width / size.height : size.height / size.width;
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var val = detectDevice();
    setDevice(val);
  }, [aspectRatio]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var leftBox = document.getElementsByClassName("custom-card-left")[0]; // console.log("Width is equls to ", leftBox.offsetWidth);

    setRelatedWidth(leftBox.offsetWidth);
  }, [size.width]);

  function getTimeDif(x) {
    var startTime = new Date(x);
    var endTime = new Date(); // Current system time
    // Calculate the difference in milliseconds

    var diffInMs = endTime - startTime; // Convert the difference to hours

    var diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));

    if (diffInHours < 1) {
      // Calculate the difference in minutes and round to the nearest whole number
      var diffInMinutes = Math.round(diffInMs / (1000 * 60));
      return "".concat(diffInMinutes, " mins ago");
    }

    if (diffInHours < 24) {
      // Show in hours if less than 24 hours
      return "".concat(diffInHours, " hour").concat(diffInHours !== 1 ? "s" : "", " ago");
    }

    var diffInDays = Math.floor(diffInHours / 24);

    if (diffInDays < 30) {
      // Show in days if less than 30 days
      return "".concat(diffInDays, " day").concat(diffInDays !== 1 ? "s" : "", " ago");
    }

    var diffInMonths = Math.floor(diffInDays / 30);

    if (diffInMonths < 12) {
      // Show in months if less than 12 months
      return "".concat(diffInMonths, " month").concat(diffInMonths !== 1 ? "s" : "", " ago");
    }

    var diffInYears = Math.floor(diffInMonths / 12); // Show in years if 12 months or more

    return "".concat(diffInYears, " year").concat(diffInYears !== 1 ? "s" : "", " ago");
  }

  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var _arraysData$indexonSc13, _arraysData$indexonSc14, _arraysData$indexonSc15, _arraysData$indexonSc16;

    var share = {
      title: (_arraysData$indexonSc13 = arraysData[indexonScreen]) === null || _arraysData$indexonSc13 === void 0 ? void 0 : _arraysData$indexonSc13.title,
      text: (_arraysData$indexonSc14 = arraysData[indexonScreen]) === null || _arraysData$indexonSc14 === void 0 ? void 0 : _arraysData$indexonSc14.title
    }; //if (shareUrl) share.url = shareUrl;

    share.url = ((_arraysData$indexonSc15 = arraysData[indexonScreen]) === null || _arraysData$indexonSc15 === void 0 ? void 0 : _arraysData$indexonSc15.permalink) + "?utm_source=Internal_LT&utm_medium=".concat((_arraysData$indexonSc16 = arraysData[indexonScreen]) === null || _arraysData$indexonSc16 === void 0 ? void 0 : _arraysData$indexonSc16.type, "&utm_name=system-share"); //console.log("share: ", share);

    setShareData(share);
  }, [indexonScreen]);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var script = document.createElement('script');
    script.src = 'https://www.instagram.com/embed.js';
    script.defer = true; // script.onload = () => {
    //   console.log(window.instgrm , ' window.instgrm');
    //   if (window.instgrm) {
    //     window.instgrm.Embeds.process();
    //   }
    // };

    document.body.appendChild(script);
  }, []);
  (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function () {
    var observer = new MutationObserver(function (mutations, obs) {
      var box = document.querySelector('.tbl-read-more-box');

      if (box) {
        // box.style.position = 'relative';
        box.style.zIndex = '10';
        obs.disconnect(); // stop observing
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
    style: {
      minHeight: "90vh"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("link", {
        rel: "amphtml",
        href: "".concat("https://www.thelallantop.com", "/amp/").concat((_arraysData$indexonSc17 = arraysData[indexonScreen]) === null || _arraysData$indexonSc17 === void 0 ? void 0 : _arraysData$indexonSc17.categorySlug, "/video/").concat((_arraysData$indexonSc18 = arraysData[indexonScreen]) === null || _arraysData$indexonSc18 === void 0 ? void 0 : _arraysData$indexonSc18.postSlug)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        property: "fb:pages",
        content: "1453842511589254"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        property: "article:published_time" // content={convertToIST(arraysData[indexonScreen]?.publishedAt)}
        ,
        content: (_arraysData$indexonSc19 = arraysData[indexonScreen]) === null || _arraysData$indexonSc19 === void 0 ? void 0 : _arraysData$indexonSc19.publishedAtIST
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        property: "article:modified_time",
        content: (_arraysData$indexonSc20 = arraysData[indexonScreen]) === null || _arraysData$indexonSc20 === void 0 ? void 0 : _arraysData$indexonSc20.updatedAtIST
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        name: "twitter:title",
        content: (_arraysData$indexonSc21 = arraysData[indexonScreen]) === null || _arraysData$indexonSc21 === void 0 ? void 0 : _arraysData$indexonSc21.title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        name: "twitter:image",
        content: (_arraysData$indexonSc22 = arraysData[indexonScreen]) === null || _arraysData$indexonSc22 === void 0 ? void 0 : _arraysData$indexonSc22.headingImageUrl
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        name: "twitter:site_name",
        content: "The Lallantop"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        name: "twitter:description",
        content: (_arraysData$indexonSc23 = arraysData[indexonScreen]) === null || _arraysData$indexonSc23 === void 0 ? void 0 : _arraysData$indexonSc23.shortText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        name: "twitter:url",
        content: ((_arraysData$indexonSc24 = arraysData[indexonScreen]) === null || _arraysData$indexonSc24 === void 0 ? void 0 : _arraysData$indexonSc24.permalink) || ((_arraysData$indexonSc25 = arraysData[indexonScreen]) === null || _arraysData$indexonSc25 === void 0 ? void 0 : (_arraysData$indexonSc26 = _arraysData$indexonSc25.seoData) === null || _arraysData$indexonSc26 === void 0 ? void 0 : _arraysData$indexonSc26.canonicalURL)
      }), keywords && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("meta", {
        name: "keywords",
        content: "".concat(keywords)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("link", {
        // rel="preconnect"
        crossOrigin: "true",
        href: "https://static.chartbeat.com"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
      title: (_arraysData$indexonSc27 = arraysData[indexonScreen]) === null || _arraysData$indexonSc27 === void 0 ? void 0 : (_arraysData$indexonSc28 = _arraysData$indexonSc27.seoData) === null || _arraysData$indexonSc28 === void 0 ? void 0 : _arraysData$indexonSc28.metaTitle // "" +
      // (arraysData[indexonScreen]?.type === "text" ? " Article" : " Video")
      // arraysData[indexonScreen]?.title +" - The Lallantop"
      ,
      description: (_arraysData$indexonSc29 = arraysData[indexonScreen]) === null || _arraysData$indexonSc29 === void 0 ? void 0 : (_arraysData$indexonSc30 = _arraysData$indexonSc29.seoData) === null || _arraysData$indexonSc30 === void 0 ? void 0 : _arraysData$indexonSc30.metaDescription,
      canonical: ((_arraysData$indexonSc31 = arraysData[indexonScreen]) === null || _arraysData$indexonSc31 === void 0 ? void 0 : _arraysData$indexonSc31.permalink) || ((_arraysData$indexonSc32 = arraysData[indexonScreen]) === null || _arraysData$indexonSc32 === void 0 ? void 0 : (_arraysData$indexonSc33 = _arraysData$indexonSc32.seoData) === null || _arraysData$indexonSc33 === void 0 ? void 0 : _arraysData$indexonSc33.canonicalURL),
      datePublished: (_arraysData$indexonSc34 = arraysData[indexonScreen]) === null || _arraysData$indexonSc34 === void 0 ? void 0 : _arraysData$indexonSc34.publishedAtIST,
      dateModified: (_arraysData$indexonSc35 = arraysData[indexonScreen]) === null || _arraysData$indexonSc35 === void 0 ? void 0 : _arraysData$indexonSc35.updatedAtIST,
      openGraph: {
        url: ((_arraysData$indexonSc36 = arraysData[indexonScreen]) === null || _arraysData$indexonSc36 === void 0 ? void 0 : _arraysData$indexonSc36.permalink) || ((_arraysData$indexonSc37 = arraysData[indexonScreen]) === null || _arraysData$indexonSc37 === void 0 ? void 0 : (_arraysData$indexonSc38 = _arraysData$indexonSc37.seoData) === null || _arraysData$indexonSc38 === void 0 ? void 0 : _arraysData$indexonSc38.canonicalURL),
        title: (_arraysData$indexonSc39 = arraysData[indexonScreen]) === null || _arraysData$indexonSc39 === void 0 ? void 0 : _arraysData$indexonSc39.title,
        description: (_arraysData$indexonSc40 = arraysData[indexonScreen]) === null || _arraysData$indexonSc40 === void 0 ? void 0 : _arraysData$indexonSc40.shortText,
        type: "website",
        images: [{
          url: (_arraysData$indexonSc41 = arraysData[indexonScreen]) === null || _arraysData$indexonSc41 === void 0 ? void 0 : _arraysData$indexonSc41.headingImageUrl,
          alt: (_arraysData$indexonSc42 = arraysData[indexonScreen]) === null || _arraysData$indexonSc42 === void 0 ? void 0 : _arraysData$indexonSc42.imgCaption
        }],
        site_name: "The Lallantop"
      },
      twitter: {
        handle: "@TheLallantop",
        site: "@TheLallantop",
        cardType: "summary_large_image"
      },
      facebook: {
        appId: "574628820637757"
      },
      robotsProps: {
        // maxSnippet: -1,
        maxImagePreview: "large" // noindex : -1,
        // nofollow : -1
        // maxVideoPreview: -1,

      } // additionalMetaTags={[{
      //   name: 'googlebot',
      //   content:'max-image-preview: standard'
      // },{
      //   name: 'robots',
      //   content:'max-image-preview: large'
      // }]}

    }), firstScroll && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(RecengineWidget, {
      size: size,
      postId: postData === null || postData === void 0 ? void 0 : postData._id
    }), categoryName == 'sports' && masterConfigCT['ChampionsTrophyWidget']['ShowWidgetOnAllSport'] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(WidgetHome, {
        newsData: cricketTopicData,
        scoreData: scoreData,
        pointsData: pointsData,
        table: (pointsData === null || pointsData === void 0 ? void 0 : (_pointsData$standings = pointsData.standings) === null || _pointsData$standings === void 0 ? void 0 : (_pointsData$standings2 = _pointsData$standings.stage1) === null || _pointsData$standings2 === void 0 ? void 0 : _pointsData$standings2.groups[0]) || "",
        size: size
      })
    }), (articlePageBanners === null || articlePageBanners === void 0 ? void 0 : articlePageBanners.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
      className: "checkMobileOrNot ".concat((articlePageBanners === null || articlePageBanners === void 0 ? void 0 : articlePageBanners.length) === 1 ? "stickyArticleBanner" : "", " ").concat((articlePageBanners === null || articlePageBanners === void 0 ? void 0 : articlePageBanners.length) === 1 && !showStickyBanner ? "remove-sticky" : ""),
      style: {
        margin: "5px 6px 0 6px"
      },
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(DynamicBanner, {
        list: articlePageBanners,
        type: "msite",
        fromArticlePage: true,
        setShowStickyBanner: setShowStickyBanner,
        showStickyBanner: showStickyBanner,
        page: "video-article"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
      className: "content-wrapper",
      style: {
        minHeight: "250px"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
          className: "container-row content-container",
          children: arraysData.map(function (articleData, index) {
            var _articleData$englishT, _articleData$englishT2, _articleData$contentA, _articleData$contentA2, _articleData$contentA3, _articleData$contentA4, _articleData$contentA5, _articleData$inputAut, _articleData$publishe, _articleData$updatedA, _articleData$publishe2, _articleData$updatedA2, _articleData$contentA6, _articleData$contentA7, _articleData$inputAut2, _bookmarkArticleArray2, _articleData$contentA8, _articleData$inputAut3, _articleData$publishe3, _articleData$updatedA3, _articleData$publishe4, _articleData$updatedA4, _bookmarkArticleArray3, _articleData$faqs, _articleData$topicIte, _articleData$topicIte2, _homePageVideos$entit, _homePageVideos$entit2, _homePageVideos$entit3, _homePageVideos$entit4;

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
              className: "infinite articles ".concat(index),
              children: [indexonScreen === index && size.width > 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                className: "container-row py-2 deaktop-header-ad",
                align: "center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h5", {
                  id: "ads",
                  style: {
                    fontSize: "11px",
                    color: "#b7b7b7",
                    textAlign: "center",
                    marginBottom: "0px"
                  },
                  children: "Advertisement"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                  id: "div-gpt-ad-1701945163318-0",
                  style: {
                    minWidth: "300px",
                    minHeight: size.width > 700 ? "100px" : "260px",
                    display: "block !important",
                    alignContent: "center",
                    textAlign: "-webkit-center"
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
                    type: "text/javascript",
                    dangerouslySetInnerHTML: {
                      __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945163318-0')})"
                    }
                  })
                })]
              }), indexonScreen === index && !(size.width > 700) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                className: "container-row py-2 mobile-header-ad",
                align: "center",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                  id: "ads",
                  style: {
                    fontSize: "11px",
                    color: "#b7b7b7",
                    textAlign: "center",
                    marginBottom: "0px"
                  },
                  children: "Advertisement"
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                  id: "div-gpt-ad-1701946028239-0",
                  style: {
                    minWidth: "300px",
                    minHeight: "260px",
                    display: "block !important",
                    alignContent: "center",
                    textAlign: "-webkit-center"
                  },
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
                    type: "text/javascript",
                    dangerouslySetInnerHTML: {
                      __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-0')})"
                    }
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("ul", {
                className: "breadcrumb-article breadcrumb-article-page",
                style: {
                  backgroundColor: "#f3f4f5",
                  paddingBottom: "10px"
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                    href: "/",
                    passHref: true,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("a", {
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("i", {
                        className: "icon-cat-home"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                        children: "Home"
                      })]
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                    href: "/".concat(articleData === null || articleData === void 0 ? void 0 : articleData.categorySlug),
                    passHref: true,
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                        children: language === "hi" ? articleData === null || articleData === void 0 ? void 0 : articleData.categoryName : articleData === null || articleData === void 0 ? void 0 : articleData.categoryName
                      })
                    })
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("li", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                    //   href={`/${mainUrl}/${query?.categoryName}/${postStateData?.subCategorySlug}`}
                    passHref: true,
                    style: {
                      color: "#999999"
                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                        children: language === "hi" ? size.width < 768 ? articleData === null || articleData === void 0 ? void 0 : articleData.englishTitle : "".concat(articleData === null || articleData === void 0 ? void 0 : (_articleData$englishT = articleData.englishTitle) === null || _articleData$englishT === void 0 ? void 0 : _articleData$englishT.slice(0, 60), "...") : size.width < 768 ? articleData === null || articleData === void 0 ? void 0 : articleData.englishTitle : "".concat(articleData === null || articleData === void 0 ? void 0 : (_articleData$englishT2 = articleData.englishTitle) === null || _articleData$englishT2 === void 0 ? void 0 : _articleData$englishT2.slice(0, 60), "...")
                      })
                    })
                  })
                })]
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                className: fontSize === "small" ? "card-wrapper new-details-small" : fontSize === "large" ? "card-wrapper new-details-large" : "card-wrapper new-details",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                  className: "card-left custom-card-left",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                    className: "card-left-main",
                    style: {
                      backgroundColor: "white"
                    },
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                      style: {
                        position: "relative",
                        backgroundColor: "black",
                        backgroundImage: "linear-gradient(to bottom, transparent, rgba(0, 0, 0, .4) 0.1%, rgba(0, 0, 0, .4) 100%), url('".concat(articleData === null || articleData === void 0 ? void 0 : articleData.headingImageUrl, "?quality=2&width=320')"),
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        aspectRatio: "16/9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        // Mimic a video player feel
                        transition: "opacity 250ms cubic-bezier(0, .25, .25, 1), background-size 250ms cubic-bezier(0, .25, .25, 1)" // Smooth transition

                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                          id: "jwplayer-container-".concat(index),
                          style: {
                            // backgroundColor: "black",
                            backgroundSize: "100%",
                            // backgroundImage: `url('${articleData?.headingImageUrl}?quality=2&width=320')`,
                            aspectRatio: "16/9"
                          },
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 240 240",
                            focusable: "false",
                            width: size.width > 700 ? "88" : size.width < 420 ? "44" : "77",
                            height: size.width > 700 ? "88" : size.width < 420 ? "44" : "77",
                            fill: "white",
                            style: {
                              opacity: 0.9,
                              transition: "opacity 0.3s"
                            },
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("path", {
                              d: "M62.8,199.5c-1,0.8-2.4,0.6-3.3-0.4c-0.4-0.5-0.6-1.1-0.5-1.8V42.6c-0.2-1.3,0.7-2.4,1.9-2.6c0.7-0.1,1.3,0.1,1.9,0.4l154.7,77.7c2.1,1.1,2.1,2.8,0,3.8L62.8,199.5z"
                            })
                          })
                        })
                      })
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                      className: "share-box-videopage",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                          href: "https://news.google.com/publications/CAAqBwgKMLqg_Qowk8r0Ag",
                          target: "_blank",
                          rel: "noreferrer",
                          style: {
                            marginRight: "25px"
                          },
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                            src: "/assets/images/google-news.png",
                            width: "116px",
                            height: ""
                          })
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                        style: {
                          display: "flex",
                          gap: "8px",
                          alignItems: "center"
                        },
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                          src: "/assets/images/share-video.png",
                          width: "32px",
                          height: "32px",
                          onClick: function onClick() {
                            handleShare(articleData);
                          },
                          style: {
                            cursor: "pointer"
                          }
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(TwitterShareButton, {
                          title: shareData.text,
                          url: shareData.url,
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                            src: "https://static.thelallantop.com/images/post/1728905954467_twitter-x-logo-black-round-20851.webp?width=32",
                            width: "32px",
                            height: "32px"
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(WhatsappShareButton, {
                          url: shareData.url,
                          title: shareData.text,
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                            src: "/assets/images/whatsapp-video.png",
                            width: "32px",
                            height: "32px"
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(FacebookShareButton, {
                          quote: shareData.text,
                          url: shareData.url,
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                            src: "/assets/images/facebook-video.png",
                            width: "32px",
                            height: "32px"
                          })
                        })]
                      })]
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                      className: "card-body post-body",
                      style: {
                        border: "none"
                      },
                      id: "video-content-body",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                        className: fontSize === "small" ? "news-title-small" : fontSize === "large" ? "news-title-large" : "news-title",
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h1", {
                          children: articleData === null || articleData === void 0 ? void 0 : articleData.title
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h2", {
                        children: articleData === null || articleData === void 0 ? void 0 : articleData.shortText
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                        className: fontSize === "small" ? "news-options-small display-block author-box" : fontSize === "large" ? "news-options-large display-block author-box" : "news-options display-block author-box",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                          className: "author-section",
                          style: {
                            display: "flex"
                          },
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                            className: "user user-section",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                              className: "image",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                className: "image-thumb",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                                  src: (articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA = articleData.contentAuthors[0]) === null || _articleData$contentA === void 0 ? void 0 : _articleData$contentA.profileImage) + "?width=60",
                                  width: "60",
                                  height: "60",
                                  alt: "pic"
                                })
                              })
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                              className: "user-detail",
                              style: {
                                maxWidth: "100%"
                              },
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                                href: "/authors/".concat((articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA2 = articleData.contentAuthors[0]) === null || _articleData$contentA2 === void 0 ? void 0 : (_articleData$contentA3 = _articleData$contentA2.email) === null || _articleData$contentA3 === void 0 ? void 0 : _articleData$contentA3.split("@")[0])),
                                passHref: true,
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                                  style: {
                                    color: "black"
                                  },
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                    className: "name second-author-name",
                                    children: (articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA4 = articleData.contentAuthors[0]) === null || _articleData$contentA4 === void 0 ? void 0 : _articleData$contentA4.fullname)
                                  })
                                })
                              }), !((articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA5 = articleData.contentAuthors) === null || _articleData$contentA5 === void 0 ? void 0 : _articleData$contentA5.length) > 1 || (articleData === null || articleData === void 0 ? void 0 : (_articleData$inputAut = articleData.inputAuthors) === null || _articleData$inputAut === void 0 ? void 0 : _articleData$inputAut.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                className: "date date-fix-overflow",
                                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                                  className: "date-desktop",
                                  children: (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).date
                                }), (postData === null || postData === void 0 ? void 0 : postData.seriesId) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("span", {
                                  className: "date-desktop",
                                  children: [" ", " (", language === "hi" ? "पब्लिश्ड: " : "Published: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).time, " IST", ")"]
                                }), !(postData !== null && postData !== void 0 && postData.seriesId) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe = articleData.publishedAt) === null || _articleData$publishe === void 0 ? void 0 : _articleData$publishe.toString()) !== (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA = articleData.updatedAt) === null || _articleData$updatedA === void 0 ? void 0 : _articleData$updatedA.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("span", {
                                  className: "date-desktop",
                                  children: [" ", " (", language === "hi" ? "अपडेटेड: " : "Updated: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).date, ", ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).time, " IST", ")"]
                                }), !(postData !== null && postData !== void 0 && postData.seriesId) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe2 = articleData.publishedAt) === null || _articleData$publishe2 === void 0 ? void 0 : _articleData$publishe2.toString()) === (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA2 = articleData.updatedAt) === null || _articleData$updatedA2 === void 0 ? void 0 : _articleData$updatedA2.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("span", {
                                  className: "date-desktop",
                                  children: [" ", " (", language === "hi" ? "पब्लिश्ड: " : "Published: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).time, " IST", ")"]
                                })]
                              })]
                            })]
                          }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA6 = articleData.contentAuthors) === null || _articleData$contentA6 === void 0 ? void 0 : _articleData$contentA6.length) > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                            className: "user user-section",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                              className: "image",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                className: "image-thumb",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                                  src: (articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors) && "".concat(articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors[1].profileImage, "?width=60"),
                                  width: "60",
                                  height: "60",
                                  alt: "pic"
                                })
                              })
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                              className: "user-detail",
                              style: {
                                maxWidth: "100%"
                              },
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                                href: "/authors/".concat(articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors[1].email.split("@")[0]),
                                passHref: true,
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                                  style: {
                                    color: "black"
                                  },
                                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                    className: "name second-author-name",
                                    children: articleData === null || articleData === void 0 ? void 0 : articleData.contentAuthors[1].fullname
                                  })
                                })
                              })
                            })]
                          }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA7 = articleData.contentAuthors) === null || _articleData$contentA7 === void 0 ? void 0 : _articleData$contentA7.length) === 1 && (articleData === null || articleData === void 0 ? void 0 : (_articleData$inputAut2 = articleData.inputAuthors) === null || _articleData$inputAut2 === void 0 ? void 0 : _articleData$inputAut2.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                            className: "user user-section",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                              className: "image",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                className: "image-thumb",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                                  src: "https://static.thelallantop.com/images/post/1690873523564_lallatop-logo-m.webp&width=60&q=75",
                                  width: "60",
                                  height: "60",
                                  alt: "pic"
                                })
                              })
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                              className: "user-detail",
                              style: {
                                maxWidth: "inherit"
                              },
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                className: "name second-author-name",
                                children: articleData === null || articleData === void 0 ? void 0 : articleData.inputAuthors[0]
                              })
                            })]
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                            className: "options mobile-options d-visible-icons",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_FontSize__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                              setFontSize: setFontSize,
                              fontSize: fontSize
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                              className: "btns",
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("i", {
                                onClick: function onClick() {
                                  handleBookmark((articleData === null || articleData === void 0 ? void 0 : articleData.postId) || (articleData === null || articleData === void 0 ? void 0 : articleData._id), articleData === null || articleData === void 0 ? void 0 : articleData.type, index);
                                },
                                title: "bookmark",
                                style: {
                                  fontWeight: "600"
                                },
                                className: "icon-bookmark".concat((_bookmarkArticleArray2 = bookmarkArticleArray[index]) !== null && _bookmarkArticleArray2 !== void 0 && _bookmarkArticleArray2.isBookmarked ? "-fill" : ""),
                                role: "button",
                                "aria-label": "Bookmark Toggle"
                              })
                            })]
                          })]
                        }), ((articleData === null || articleData === void 0 ? void 0 : (_articleData$contentA8 = articleData.contentAuthors) === null || _articleData$contentA8 === void 0 ? void 0 : _articleData$contentA8.length) > 1 || (articleData === null || articleData === void 0 ? void 0 : (_articleData$inputAut3 = articleData.inputAuthors) === null || _articleData$inputAut3 === void 0 ? void 0 : _articleData$inputAut3.length) > 0) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                          className: "date date-fix-overflow",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                            className: "date-desktop",
                            children: (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).date
                          }), (postData === null || postData === void 0 ? void 0 : postData.seriesId) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("span", {
                            className: "date-desktop",
                            children: [" ", " (", language === "hi" ? "पब्लिश्ड: " : "Published: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).time, " IST", ")"]
                          }), !(postData !== null && postData !== void 0 && postData.seriesId) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe3 = articleData.publishedAt) === null || _articleData$publishe3 === void 0 ? void 0 : _articleData$publishe3.toString()) !== (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA3 = articleData.updatedAt) === null || _articleData$updatedA3 === void 0 ? void 0 : _articleData$updatedA3.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("span", {
                            className: "date-desktop",
                            children: [" ", " (", language === "hi" ? "अपडेटेड: " : "Updated: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDate */ .p6)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).date, ", ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.updatedAt).time, " IST", ")"]
                          }), !(postData !== null && postData !== void 0 && postData.seriesId) && (articleData === null || articleData === void 0 ? void 0 : (_articleData$publishe4 = articleData.publishedAt) === null || _articleData$publishe4 === void 0 ? void 0 : _articleData$publishe4.toString()) === (articleData === null || articleData === void 0 ? void 0 : (_articleData$updatedA4 = articleData.updatedAt) === null || _articleData$updatedA4 === void 0 ? void 0 : _articleData$updatedA4.toString()) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("span", {
                            className: "date-desktop",
                            children: [" ", " (", language === "hi" ? "पब्लिश्ड: " : "Published: ", (0,constants_cardsConstant__WEBPACK_IMPORTED_MODULE_10__/* .formatDateIST */ .Pj)(articleData === null || articleData === void 0 ? void 0 : articleData.publishedAt).time, " IST", ")"]
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                          className: "options mobile-options m-visible-icons",
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(_FontSize__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            setFontSize: setFontSize,
                            fontSize: fontSize
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                            className: "btns",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("i", {
                              onClick: function onClick() {
                                handleBookmark((articleData === null || articleData === void 0 ? void 0 : articleData.postId) || (articleData === null || articleData === void 0 ? void 0 : articleData._id), articleData === null || articleData === void 0 ? void 0 : articleData.type, index);
                              },
                              title: "bookmark",
                              style: {
                                fontWeight: "600"
                              },
                              className: "icon-bookmark".concat((_bookmarkArticleArray3 = bookmarkArticleArray[index]) !== null && _bookmarkArticleArray3 !== void 0 && _bookmarkArticleArray3.isBookmarked ? "-fill" : ""),
                              role: "button",
                              "aria-label": "Bookmark Toggle"
                            })
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                            className: "btns",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("i", {
                              onClick: function onClick() {
                                handleShare(articleData);
                              },
                              title: "share",
                              style: {
                                fontWeight: "600",
                                fontSize: "2.1rem"
                              },
                              className: "icon-share",
                              "aria-label": "Share Button",
                              role: "link"
                            })
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                            className: "btns d-flex align-items-center",
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                              "aria-label": "Whatsapp Share Button",
                              role: "link",
                              title: "whatsapp",
                              onClick: function onClick() {
                                shareLinkToWhatsApp(articleData);
                              },
                              src: "/assets/images/whatsapp2.png",
                              width: 20,
                              height: 20,
                              alt: "whatsapp share"
                            })
                          })]
                        })]
                      }), firstScroll && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(ArticleHTML, {
                        postData: articleData,
                        postStateData: articleData,
                        isFirstTime: isFirstTime,
                        indexonScreen: indexonScreen,
                        articleIndex: index,
                        showMore: showMore[index],
                        relatedArticles: (homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.length) > 0 ? homePageVideos : relatedArticles // replaces the need to call related articles API
                        ,
                        handleShowMore: function handleShowMore() {
                          return handleReadMore(index);
                        }
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                        style: showMore[index] ? {
                          display: "block"
                        } : {
                          display: "none"
                        }
                      })]
                    })]
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                    style: showMore[index] ? {
                      display: "block"
                    } : {
                      display: "none"
                    },
                    children: [index === 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                      className: "first-article-observer"
                    }), firstScroll && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(CommentSection, {
                      postData: articleData,
                      postStateData: articleData,
                      ref: ref,
                      language: language,
                      setLoginPrompt: setLoginPrompt,
                      commentIndex: index,
                      isVisible: showMore[index]
                    }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$faqs = articleData.faqs) === null || _articleData$faqs === void 0 ? void 0 : _articleData$faqs.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(FAQComponent, {
                      data: articleData === null || articleData === void 0 ? void 0 : articleData.faqs
                    }), (articleData === null || articleData === void 0 ? void 0 : (_articleData$topicIte = articleData.topicItems) === null || _articleData$topicIte === void 0 ? void 0 : _articleData$topicIte.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                      className: "card-body news-hashtag",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h2", {
                        className: "title text-black mb-2",
                        style: {
                          fontWeight: "600"
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(FormattedMessage, {
                          id: "topics_mentioned",
                          defaultMessage: "\u0907\u0938 \u092A\u094B\u0938\u094D\u091F \u0938\u0947 \u091C\u0941\u095C\u0947 \u0939\u0941\u090F \u091F\u0949\u092A\u093F\u0915"
                        })
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("ul", {
                        className: "hashtags-list",
                        children: articleData === null || articleData === void 0 ? void 0 : (_articleData$topicIte2 = articleData.topicItems) === null || _articleData$topicIte2 === void 0 ? void 0 : _articleData$topicIte2.map(function (topic, index) {
                          var _articleData$topicIte3;

                          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("li", {
                            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                              href: "/topic/".concat(topic === null || topic === void 0 ? void 0 : topic.slug),
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("a", {
                                children: [topic === null || topic === void 0 ? void 0 : topic.title, index !== (articleData === null || articleData === void 0 ? void 0 : (_articleData$topicIte3 = articleData.topicItems) === null || _articleData$topicIte3 === void 0 ? void 0 : _articleData$topicIte3.length) - 1 && ","]
                              })
                            })
                          }, index);
                        })
                      })]
                    })]
                  })]
                }), size.width <= 700 ? index === 4 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                  className: "card-right min-width-ads card-right-ad ",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                    className: "bottom-ads container-row py-2 ",
                    align: "center",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                      id: "ads",
                      style: {
                        fontSize: "11px",
                        color: "#b7b7b7",
                        marginBottom: "0px"
                      },
                      children: "Advertisement"
                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                      id: "div-gpt-ad-1701945220410-1",
                      style: {
                        minWidth: "300px",
                        minHeight: "100px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center"
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-1')})"
                        }
                      })
                    })]
                  })
                }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                  className: "card-right min-width-ads card-right-ad",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                    className: "container-row",
                    align: "center",
                    style: {
                      minWidth: "300px",
                      minHeight: "250px",
                      display: "block !important"
                    },
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                      id: "ads",
                      style: {
                        fontSize: "11px",
                        color: "#b7b7b7",
                        marginBottom: "0px"
                      },
                      children: "Advertisement"
                    }), indexonScreen === index && size.width > 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                      id: "div-gpt-ad-1701945220410-0",
                      style: {
                        minWidth: "300px",
                        minHeight: "260px",
                        display: "block !important",
                        alignContent: "center",
                        textAlign: "-webkit-center"
                      },
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-0')})"
                        }
                      })
                    }), indexonScreen === index && size.width < 700 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                      id: "div-gpt-ad-1701946028239-1",
                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
                        type: "text/javascript",
                        dangerouslySetInnerHTML: {
                          __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-1')})"
                        }
                      })
                    })]
                  }), (postData === null || postData === void 0 ? void 0 : postData.seriesId) && index == 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(MoreEpisodes, {
                    postData: postData,
                    size: size,
                    seriesSlug: postData === null || postData === void 0 ? void 0 : postData.seriesSlug
                  }), !(postData !== null && postData !== void 0 && postData.seriesId) && index === 0 && (homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit = homePageVideos.entities) === null || _homePageVideos$entit === void 0 ? void 0 : _homePageVideos$entit.length) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                    className: "chunav-yatra-article",
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                      className: "electionYatra-outer-home-article",
                      style: {
                        backgroundColor: homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.backgroundColor
                      },
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                        className: "electionYatra-header-article",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                            src: homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.icon,
                            width: "30px",
                            height: "30px",
                            alt: "election-icon"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                            style: {
                              marginLeft: "10px",
                              fontSize: "20px"
                            },
                            children: language === "hi" ? homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.titleHn : homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.title
                          })]
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                          className: "election-aurDekhe-article",
                          onClick: function onClick() {
                            return router.push("/topic/chunav-yatra-2024");
                          },
                          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                            style: {
                              marginRight: "10px"
                            },
                            children: language === "hi" ? "और देखें" : "see more"
                          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                            src: "/assets/images/arrow.png",
                            width: "15px",
                            height: "15px"
                          })]
                        })]
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                        className: "electionYatra-columns-article",
                        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                          href: "".concat(homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit2 = homePageVideos.entities[0]) === null || _homePageVideos$entit2 === void 0 ? void 0 : _homePageVideos$entit2.permalink),
                          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                            className: "electionYatra-second-article election-mobile-article",
                            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                              className: "electionYatra-second-top-article",
                              style: {
                                position: "relative"
                              },
                              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                                src: "".concat(homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit3 = homePageVideos.entities[0]) === null || _homePageVideos$entit3 === void 0 ? void 0 : _homePageVideos$entit3.headingImageUrl, "?q=25&width=320")
                              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("i", {
                                className: "icon-play-circle",
                                width: "500px",
                                height: "500px",
                                style: {
                                  color: "white",
                                  position: "absolute",
                                  left: "2px",
                                  bottom: "-5px",
                                  width: "500px"
                                }
                              })]
                            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                              className: "electionYatra-second-bottom-article",
                              style: {
                                fontSize: "17px"
                              },
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h2", {
                                children: homePageVideos === null || homePageVideos === void 0 ? void 0 : (_homePageVideos$entit4 = homePageVideos.entities[0]) === null || _homePageVideos$entit4 === void 0 ? void 0 : _homePageVideos$entit4.title
                              })
                            })]
                          })
                        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                          style: {
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between"
                          },
                          children: homePageVideos === null || homePageVideos === void 0 ? void 0 : homePageVideos.entities.slice(1).map(function (x, index) {
                            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("a", {
                              href: "".concat(x === null || x === void 0 ? void 0 : x.permalink),
                              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                className: "electionYatra-first-article",
                                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                  className: "electionYatra-first-div-article",
                                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                    style: {
                                      flex: "0 0 40%",
                                      position: "relative",
                                      justifyContent: "center",
                                      alignContent: "center",
                                      alignItems: "center"
                                    },
                                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                                      src: "".concat(x === null || x === void 0 ? void 0 : x.headingImageUrl, "?q=1&width=180")
                                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("i", {
                                      className: "icon-play-circle",
                                      style: {
                                        color: "white",
                                        position: "absolute",
                                        left: "2px",
                                        bottom: "-5px"
                                      }
                                    })]
                                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                                    className: "electionYatra-first-div-right-article",
                                    style: {
                                      flex: "0 0 60%"
                                    },
                                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                        style: {
                                          overflow: "hidden"
                                        },
                                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                          style: {
                                            display: "-webkit-box",
                                            lineHeight: "20px",
                                            WebkitLineClamp: "3",
                                            WebkitBoxOrient: "vertical",
                                            fontSize: "16px"
                                          },
                                          className: "chunav-yatra-small-title-article",
                                          children: x === null || x === void 0 ? void 0 : x.title
                                        })
                                      })
                                    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                                      style: {
                                        display: "flex",
                                        gap: "1rem"
                                      }
                                    })]
                                  })]
                                })
                              })
                            }, index);
                          })
                        })]
                      })]
                    })
                  }), indexonScreen === index && index === 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                    align: "center",
                    style: {
                      marginTop: "1rem"
                    },
                    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                      className: "container-row py-2",
                      align: "center",
                      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                        id: "ads",
                        style: {
                          fontSize: "11px",
                          color: "#b7b7b7",
                          marginBottom: "0px"
                        },
                        children: "Advertisement"
                      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                        id: "div-gpt-ad-1701945864013-0",
                        style: {
                          minWidth: "300px",
                          minHeight: "260px",
                          display: "block !important",
                          alignContent: "center",
                          textAlign: "-webkit-center"
                        },
                        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
                          type: "text/javascript",
                          dangerouslySetInnerHTML: {
                            __html: "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945864013-0')})"
                          }
                        })
                      })]
                    })
                  })]
                })]
              }), index <= 3 && arraysData.length > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                separator: "",
                className: "amp-next-page-default-separator",
                tabIndex: "0",
                children: [" ", "Next ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                  className: "triangle_down",
                  children: " "
                }), " "]
              })]
            }, index);
          })
        })
      }), size.width < 700 && firstScroll && (postData === null || postData === void 0 ? void 0 : postData.seriesId) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(MoreEpisodes, {
        postData: postData,
        size: size,
        seriesSlug: postData === null || postData === void 0 ? void 0 : postData.seriesSlug
      }), !(postData !== null && postData !== void 0 && postData.seriesId) && ((_trendingData$entitie = trendingData.entities) === null || _trendingData$entitie === void 0 ? void 0 : _trendingData$entitie.length) > 0 && size.width < 700 && firstScroll && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
        style: {
          paddingTop: "20px",
          background: "white"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(TrendingToday, {
          data: trendingData.entities
        })
      }), size.width > 768 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
        style: {
          display: "flex",
          margin: "auto",
          paddingLeft: "0px",
          // width: "82%",
          marginTop: "20px"
        },
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
          style: {
            flex: "1 1 auto !important",
            backgroundColor: "white",
            padding: "20px",
            borderRadius: "10px",
            width: relatedWidth
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
            className: "more-articles-heading",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(FormattedMessage, {
              id: "watch_also"
            }), "..."]
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            className: "more-articles-container",
            children: relatedArticles.slice(4, size.width < 1800 ? 7 : 8).map(function (item, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                className: "more-articles-box",
                onClick: function onClick() {
                  location.href = item === null || item === void 0 ? void 0 : item.permalink;
                },
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
                    src: "".concat(item === null || item === void 0 ? void 0 : item.headingImageUrl, "?quality=75&width=320"),
                    width: "260px",
                    height: "146px"
                  })
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("span", {
                  children: item === null || item === void 0 ? void 0 : item.title
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
                  style: {
                    display: "flex",
                    alignItems: "center"
                  },
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("i", {
                    "class": "icon-play-circle",
                    style: {
                      color: "#999"
                    }
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
                    style: {
                      color: "#999",
                      paddingTop: "4px"
                    },
                    children: getTimeDif(item.publishedAt)
                  })]
                })]
              }, index);
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
          className: "card-right"
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
        align: "center",
        style: {
          marginTop: "1rem"
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
          className: "container-row py-2",
          align: "center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("p", {
            id: "ads",
            style: {
              fontSize: "11px",
              color: "#b7b7b7",
              marginBottom: "0px"
            },
            children: "Advertisement"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            id: size.width > 700 ? "div-gpt-ad-1701945220410-3" : "div-gpt-ad-1701946028239-3",
            style: {
              minWidth: "300px",
              minHeight: size.width > 700 ? "100px" : "260px",
              display: "block !important",
              alignContent: "center",
              textAlign: "-webkit-center"
            },
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
              type: "text/javascript",
              dangerouslySetInnerHTML: {
                __html: size.width > 700 ? "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701945220410-3')})" : "{googletag.cmd.push(function() { googletag.display('div-gpt-ad-1701946028239-3')})"
              }
            })
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
      id: "taboola-below-article-thumbnails"
    }), loginPrompt && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(CommentPopup, {
      showModal: loginPrompt,
      onClose: function onClose() {
        return setLoginPrompt(false);
      }
    }), loginShow && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(CustomPopup, {
      showModal: loginShow,
      onClose: function onClose() {
        return setLoginShow(false);
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
      type: "application/ld+json" // strategy="afterInteractive"
      ,
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "VideoGallery",
          name: "".concat(postData === null || postData === void 0 ? void 0 : postData.title),
          headline: "".concat(postData === null || postData === void 0 ? void 0 : postData.title),
          image: "".concat(postData === null || postData === void 0 ? void 0 : postData.headingImageUrl),
          datePublished: "".concat(postData === null || postData === void 0 ? void 0 : postData.publishedAt),
          copyrightYear: "".concat(new Date().getFullYear()),
          description: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData = postData.seoData) === null || _postData$seoData === void 0 ? void 0 : _postData$seoData.metaDescription),
          keywords: "".concat(postData === null || postData === void 0 ? void 0 : postData.altTags),
          inLanguage: "hi",
          url: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData2 = postData.seoData) === null || _postData$seoData2 === void 0 ? void 0 : _postData$seoData2.canonicalURL),
          publisher: {
            "@type": "Organization",
            name: "लल्लनटॉप"
          },
          copyrightHolder: {
            "@type": "Thing",
            name: "Living Media India Limited"
          },
          sourceOrganization: {
            "@type": "Organization",
            name: "Living Media India Limited"
          },
          provider: {
            "@type": "Thing",
            name: "Living Media India Limited"
          }
        })
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
      type: "application/ld+json" // strategy="afterInteractive"
      ,
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ProfilePage",
          mainEntity: {
            "@id": "".concat("https://www.thelallantop.com/", "authors/").concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].email.split("@")[0]),
            name: "".concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].fullname)
          },
          hasPart: {
            "@type": "Article",
            headline: "".concat(postData === null || postData === void 0 ? void 0 : postData.title),
            url: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData3 = postData.seoData) === null || _postData$seoData3 === void 0 ? void 0 : _postData$seoData3.canonicalURL),
            datePublished: "".concat(postData === null || postData === void 0 ? void 0 : postData.publishedAt),
            author: {
              "@type": "Person",
              "@id": "".concat("https://www.thelallantop.com/", "authors/").concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].email.split("@")[0]),
              name: "".concat(postData === null || postData === void 0 ? void 0 : postData.contentAuthors[0].fullname)
            }
          }
        })
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
      id: "my-script-detail",
      type: "application/ld+json" // strategy="afterInteractive"
      ,
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [{
            "@type": "ListItem",
            position: 1,
            item: {
              "@id": "".concat("https://www.thelallantop.com/"),
              name: "Home"
            }
          }, {
            "@type": "ListItem",
            position: 2,
            item: {
              name: "".concat(postData === null || postData === void 0 ? void 0 : postData.categoryName),
              "@id": "".concat("https://www.thelallantop.com/", "/").concat(postData === null || postData === void 0 ? void 0 : postData.categorySlug)
            }
          }, {
            "@type": "ListItem",
            position: 3,
            item: {
              name: "".concat(postData === null || postData === void 0 ? void 0 : postData.englishTitle),
              "@id": "".concat(postData === null || postData === void 0 ? void 0 : postData.permalink)
            }
          }]
        })
      }
    }), postData && ((postData === null || postData === void 0 ? void 0 : postData.type) === "text" || (postData === null || postData === void 0 ? void 0 : postData.type) === "video") ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
        id: "my-script2",
        type: "application/ld+json" // strategy="afterInteractive"
        ,
        defer: true,
        dangerouslySetInnerHTML: {
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            mainEntityOfPage: {
              "@type": "WebPage",
              id: "".concat(postData !== null && postData !== void 0 && postData.permalink ? postData === null || postData === void 0 ? void 0 : postData.permalink : "")
            },
            keywords: "".concat(keywords ? keywords : ""),
            headline: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData4 = postData.seoData) === null || _postData$seoData4 === void 0 ? void 0 : _postData$seoData4.metaTitle),
            description: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData5 = postData.seoData) === null || _postData$seoData5 === void 0 ? void 0 : _postData$seoData5.metaDescription),
            inLanguage: "hi",
            articleBody: "".concat(postData === null || postData === void 0 ? void 0 : postData.articleHTMLPlainText),
            image: {
              "@type": "ImageObject",
              height: 720,
              width: 1280,
              url: "".concat(postData !== null && postData !== void 0 && postData.headingImageUrl ? postData === null || postData === void 0 ? void 0 : postData.headingImageUrl : "")
            },
            datePublished: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
            dateModified: "".concat(postData !== null && postData !== void 0 && postData.updatedAt ? postData === null || postData === void 0 ? void 0 : postData.updatedAtIST : ""),
            author: {
              "@type": "Person",
              name: "".concat(postData !== null && postData !== void 0 && postData.createdByName ? postData === null || postData === void 0 ? void 0 : postData.createdByName : ""),
              url: "".concat("https://www.thelallantop.com/", "authors/").concat(authorName)
            },
            publisher: {
              "@type": "Organization",
              name: "The Lallantop",
              url: "https://www.thelallantop.com/",
              logo: {
                "@type": "ImageObject",
                url: "https://www.thelallantop.com/assets/images/lallatop-logo.svg",
                height: 60,
                width: 600
              }
            }
          })
        }
      })
    }) : postData && (postData === null || postData === void 0 ? void 0 : postData.type) === "video" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
      id: "my-script2",
      type: "application/ld+json" // strategy="afterInteractive"
      ,
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          // "@type": "VideoObject",
          name: "".concat(postData !== null && postData !== void 0 && postData.title ? postData === null || postData === void 0 ? void 0 : postData.title : ""),
          headline: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData6 = postData.seoData) === null || _postData$seoData6 === void 0 ? void 0 : _postData$seoData6.metaTitle),
          description: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData7 = postData.seoData) === null || _postData$seoData7 === void 0 ? void 0 : _postData$seoData7.metaDescription),
          url: "".concat(postData !== null && postData !== void 0 && postData.permalink ? postData === null || postData === void 0 ? void 0 : postData.permalink : ""),
          datePublished: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
          dateModified: "".concat(postData !== null && postData !== void 0 && postData.updatedAt ? postData === null || postData === void 0 ? void 0 : postData.updatedAtIST : ""),
          uploadDate: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
          thumbnailUrl: "".concat(postData !== null && postData !== void 0 && postData.headingImageUrl ? postData === null || postData === void 0 ? void 0 : postData.headingImageUrl : "https://static.thelallantop.com/images/post/1693311123087_llt-default-backdrop.webp"),
          contentUrl: "".concat(postData !== null && postData !== void 0 && postData.assetFileLink ? postData !== null && postData !== void 0 && postData.assetFileLink.includes(".m3u8") ? postData === null || postData === void 0 ? void 0 : postData.assetFileLink.replace(".m3u8", ".mp4") : postData === null || postData === void 0 ? void 0 : postData.assetFileLink : ""),
          embedUrl: "".concat(postData !== null && postData !== void 0 && postData.assetFileLink ? postData !== null && postData !== void 0 && postData.assetFileLink.includes(".m3u8") ? postData === null || postData === void 0 ? void 0 : postData.assetFileLink.replace(".m3u8", ".mp4") : postData === null || postData === void 0 ? void 0 : postData.assetFileLink : ""),
          duration: "".concat(postData !== null && postData !== void 0 && postData.duration ? postData === null || postData === void 0 ? void 0 : postData.duration : ""),
          author: {
            "@type": "Person",
            name: "".concat(postData !== null && postData !== void 0 && postData.createdByName ? postData === null || postData === void 0 ? void 0 : postData.createdByName : ""),
            sameAs: "".concat("https://www.thelallantop.com/", "authors/").concat(authorName)
          },
          publisher: {
            "@type": "Organization",
            url: "thelallantop.com",
            name: "Lallantop",
            logo: {
              "@type": "ImageObject",
              url: "https://www.thelallantop.com/assets/images/lallatop-logo.svg",
              height: 60,
              width: 600
            }
          },
          potentialAction: {
            "@type": "SeekToAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "".concat(postData !== null && postData !== void 0 && postData.permalink ? (postData === null || postData === void 0 ? void 0 : postData.permalink) + "?t={seek_to_second_number}" : "")
            },
            "startOffset-input": {
              "@type": "PropertyValueSpecification",
              valueRequired: "http://schema.org/True",
              valueName: "seek_to_second_number"
            }
          }
        })
      }
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
      id: "my-script2",
      type: "application/ld+json" // strategy="afterInteractive"
      ,
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "VideoObject",
          name: "".concat(postData !== null && postData !== void 0 && postData.title ? postData === null || postData === void 0 ? void 0 : postData.title : ""),
          headline: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData8 = postData.seoData) === null || _postData$seoData8 === void 0 ? void 0 : _postData$seoData8.metaTitle),
          description: "".concat(postData === null || postData === void 0 ? void 0 : (_postData$seoData9 = postData.seoData) === null || _postData$seoData9 === void 0 ? void 0 : _postData$seoData9.metaDescription),
          datePublished: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
          dateModified: "".concat(postData !== null && postData !== void 0 && postData.updatedAt ? postData === null || postData === void 0 ? void 0 : postData.updatedAtIST : ""),
          uploadDate: "".concat(postData !== null && postData !== void 0 && postData.publishedAt ? postData === null || postData === void 0 ? void 0 : postData.publishedAtIST : ""),
          // keywords: `${keywords ? keywords : ""}`,
          thumbnailUrl: "".concat(postData !== null && postData !== void 0 && postData.headingImageUrl ? postData === null || postData === void 0 ? void 0 : postData.headingImageUrl : "https://static.thelallantop.com/images/post/1693311123087_llt-default-backdrop.webp"),
          contentUrl: "".concat(postData !== null && postData !== void 0 && postData.assetFileLink ? postData !== null && postData !== void 0 && postData.assetFileLink.includes(".m3u8") ? postData === null || postData === void 0 ? void 0 : postData.assetFileLink.replace(".m3u8", ".mp4") : postData === null || postData === void 0 ? void 0 : postData.assetFileLink : ""),
          embedUrl: "".concat(postData !== null && postData !== void 0 && postData.assetFileLink ? postData !== null && postData !== void 0 && postData.assetFileLink.includes(".m3u8") ? postData === null || postData === void 0 ? void 0 : postData.assetFileLink.replace(".m3u8", ".mp4") : postData === null || postData === void 0 ? void 0 : postData.assetFileLink : ""),
          duration: "".concat(postData !== null && postData !== void 0 && postData.duration ? postData === null || postData === void 0 ? void 0 : postData.duration : ""),
          author: {
            "@type": "Person",
            name: "".concat(postData !== null && postData !== void 0 && postData.createdByName ? postData === null || postData === void 0 ? void 0 : postData.createdByName : ""),
            url: "".concat("https://www.thelallantop.com/", "authors/").concat(authorName)
          },
          publisher: {
            "@type": "Organization",
            url: "thelallantop.com",
            name: "Lallantop",
            logo: {
              "@type": "ImageObject",
              url: "https://www.thelallantop.com/assets/images/lallatop-logo.svg",
              height: 60,
              width: 600
            }
          },
          potentialAction: {
            "@type": "SeekToAction",
            target: {
              "@type": "EntryPoint",
              urlTemplate: "".concat(postData !== null && postData !== void 0 && postData.permalink ? (postData === null || postData === void 0 ? void 0 : postData.permalink) + "?t={seek_to_second_number}" : "")
            },
            "startOffset-input": {
              "@type": "PropertyValueSpecification",
              valueRequired: "http://schema.org/True",
              valueName: "seek_to_second_number"
            }
          }
        })
      }
    }), (postData === null || postData === void 0 ? void 0 : (_postData$additionalS = postData.additionalSchemas) === null || _postData$additionalS === void 0 ? void 0 : _postData$additionalS.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
      id: "my-script-movie",
      type: "application/ld+json",
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(postData === null || postData === void 0 ? void 0 : (_postData$additionalS2 = postData.additionalSchemas) === null || _postData$additionalS2 === void 0 ? void 0 : _postData$additionalS2[0])
      }
    }), router.asPath.includes("/factcheck/") && (postData === null || postData === void 0 ? void 0 : postData.itemReviewed) !== "" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("script", {
      id: "my-script2",
      type: "application/ld+json" // strategy="afterInteractive"
      ,
      defer: true,
      dangerouslySetInnerHTML: {
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "ClaimReview",
          url: "".concat(postData === null || postData === void 0 ? void 0 : postData.permalink),
          claimReviewed: "".concat(postData === null || postData === void 0 ? void 0 : postData.claimReviewed),
          itemReviewed: {
            "@type": "Claim",
            author: {
              "@type": "Organization",
              name: "".concat(postData === null || postData === void 0 ? void 0 : postData.claimMakerName),
              sameAs: "".concat(postData === null || postData === void 0 ? void 0 : postData.itemReviewed)
            },
            datePublished: "".concat(postData === null || postData === void 0 ? void 0 : postData.claimDatePublished.slice(0, 10)),
            appearance: {
              "@type": "OpinionNewsArticle",
              url: "".concat(postData === null || postData === void 0 ? void 0 : postData.permalink),
              headline: "".concat(postData === null || postData === void 0 ? void 0 : postData.title),
              datePublished: "".concat(postData === null || postData === void 0 ? void 0 : postData.publishedAtIST),
              author: {
                "@type": "Person",
                name: "".concat(postData === null || postData === void 0 ? void 0 : postData.createdByName)
              },
              image: "".concat(postData === null || postData === void 0 ? void 0 : postData.headingImageUrl),
              publisher: {
                "@type": "Organization",
                name: "The Lallantop",
                logo: {
                  "@type": "ImageObject",
                  url: "https://static.thelallantop.com/images/post/1695637095493_lallantop-logo_(1).webp"
                }
              }
            }
          },
          author: {
            "@type": "Organization",
            name: "The Lallantop"
          },
          reviewRating: {
            "@type": "Rating",
            ratingValue: "".concat(postData === null || postData === void 0 ? void 0 : postData.ratingValue),
            bestRating: "5",
            worstRating: "1",
            alternateName: "".concat(postData === null || postData === void 0 ? void 0 : postData.ratingAlternateName)
          }
        })
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("style", {
      children: "\n             .jw-reset\n             {\n                @media screen and (min-width: 1200px) {\n                    border-radius: 12px !important;\n                }\n               \n            }\n            "
    })]
  });
};

/* harmony default export */ __webpack_exports__["default"] = (VideoPage);

/***/ }),

/***/ 98033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CO": function() { return /* binding */ setVideoIsShow; },
/* harmony export */   "ZF": function() { return /* binding */ getSeriesById; },
/* harmony export */   "bx": function() { return /* binding */ followedSeriesData; },
/* harmony export */   "s": function() { return /* binding */ setScoreData; }
/* harmony export */ });
/* unused harmony export getSeries */
/* harmony import */ var redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(794);
 // SERIES ACTIONS

var getSeries = function getSeries(payload) {
  return {
    type: SERIES_GET_INIT,
    payload: payload
  };
};
var getSeriesById = function getSeriesById(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SERIES_GET_BY_ID_INIT */ .oH,
    payload: payload
  };
}; // SERIES FOLLOWED ACTIONS

var followedSeriesData = function followedSeriesData(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SERIES_FOLLOWED_INIT */ .hD,
    payload: payload
  };
};
var setScoreData = function setScoreData(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SET_SCOREDATA */ .VI,
    payload: payload
  };
};
var setVideoIsShow = function setVideoIsShow(payload) {
  return {
    type: redux_actionTypes_series_actionTypes__WEBPACK_IMPORTED_MODULE_0__/* .SET_VIDEO_IS_SHOW */ .CG,
    payload: payload
  };
};

/***/ })

}]);